'use strict';

import KeyValueCache     from './../Utils/KeyValueCache';
import { OpenerRulesParser } from 'documental-js/src/ExcelRules/OpenerRulesParser.js';
import { CountFunctionParser } from 'documental-js/src/ExcelRules/CountFunctionParser.js';
import Reference from './../FHIR/Workflow/Reference.js';
import QuestionnaireResponse from './../FHIR/QuestionnaireResponse.js';
import jsonLogic from './../../../node_modules/json-logic-js/logic.js';
import AgreeDisagreeNae from './../ValueSet/AgreeDisagreeNae.js';
import DisagreeNae      from './../ValueSet/DisagreeNae.js';
import AnswerHint from './../Diagnosis/AnsweHint/Hint.js';
import AnswerHintsFromMentalStatus from './../Diagnosis/AnsweHint/AnswerHintsFromMentalStatus.js';


import i18n from "./../Localization/i18n.js"; // Only needed for this.getFakeTopicsQuestion2() and getFakeTopicsQuestion() -remove after coming from server

/**
 * Holds Questionnaire, its answers, manages enableWhen and other directives 
 * returns QuestionnaireResponse when asked. One object to hold everything related to 
 * one concrete questionnaire and it's filling. 
 * 
 */


function QuestionnaireHolder ( ) {
  
  this.originalQuestionnaire = null;
  this.answers = [];
  this.questionComments = [];
  this.answerComments = [];
  this.activeTabNumber = null;
  this.activeTabLinkId = '';
  this.answerHints = null;
  this.handleServerResponseListener = null;
  this.forceQuestionnaireReponseStatus = null;
  this.addRefugeeQuestion = false;

}


/**
 * Set Questionnaire resource retrieved from server and 
 * clear all previous answers and other values
 * 
 * @param object FHIR resource
 * @param string QuestionnaireRepsonse local ID
 */
QuestionnaireHolder.prototype.setQuestionnaireResource = function( resource, questionnaireResponseId ) {
  this.originalQuestionnaire = null;
  this.originalQuestionnaire = resource;
  this.rules = null;
  this.answers.length = 0;
  this.answersFlatList = []; // only to be used in rules checking. There are some answers not present in original questionnaire
  this.answers = [];
  this.answactiveTabNumberers = null;
  this.activeTabLinkId = '';
  this.activeTabNumber = null;
  this.answerHints = null;
  this.answerComments = [];
  this.forceQuestionnaireReponseStatus = null;

  this.questionsFlatList = this.prepareAsFlatQuestionsList( 1, resource, null );
  
  this.questionsQueue = {
    toBeAnswered : [], // current queue of questions (where next questions are taken- can change in time)
    // answeredQuestions : [], // Currenlty taken question for answering
    // skippedQuestions : [], // 
    // lastQuestionIndex : -1,
    // currentQuestionIndex : -1,
    initialQueueDone : false,
    queueFinished : false
  };
  
  //createResourceMetaSourceUrl

  this.responseResourceId = questionnaireResponseId;
  this.openerRulesParser  = new OpenerRulesParser( this.originalQuestionnaire, this );
  
  this.rawFuctionRulesList = [];
  this.rules = this.getRulesFlatListForQuestionnaire( this.originalQuestionnaire );
  //console.log( 'Opener rules found::' );
  //console.log( this.rules );
  //this.parseAndExpandRules();

  //this.testRules( );
  
  if( this.sendAnswersImmediately() ){
    console.log( 'sendAnswersImmediately' );
    window.appEventsEmitter.emit( 'questionnaire-force-send-answers' );
  }

  
  // Dirty quick fix for not sending many diffrent questionnaire repsonses to server
  if( this.handleServerResponseListener == null ){
    var that = this;
    var handleServerResponseCb = function (eventPayLoad) {
      that.handleServerResponse(eventPayLoad);
    };

    window.appEventsEmitter.addListener("server-response", handleServerResponseCb);
    this.handleServerResponseListener = handleServerResponseCb;
  }
  
};


/**
 * 
 * TODO: Should extract it somwhere else since this creates 
 * global depency on 
 *  - window.appEntityStore
 *  - window.appEventsEmitter
 */
QuestionnaireHolder.prototype.handleServerResponse = function( rawData ) {
  var justUpdated = false;

  if( rawData && typeof rawData.entry != "undefined" ){
    for( var i in rawData.entry ){
      var entryMeta = this.extractBundleEntryMetaData( rawData.entry[ i ] );
      //console.log( "QuestionnaireHolder.handleServerResponse" );
      //console.log( entryMeta );

      if( 
        entryMeta.crudAction == 'update_or_insert' && 
        entryMeta.crudActionResult && 
        typeof rawData.entry[ i ].resource != "udefined" && 
        typeof rawData.entry[ i ].resource.resourceType != "udefined" && 
        rawData.entry[ i ].resource.resourceType == "QuestionnaireResponse"
      ){
        console.log( 'xxx handleServerResponse' );
        if( entryMeta.localReference == this.responseResourceId ){
          console.log( "QHolder: Change local ID to server ID " + this.responseResourceId + " => " + entryMeta.resourceId );
          this.responseResourceId = entryMeta.resourceId;
          justUpdated = true;
        }
      }

    }
  }

  if( justUpdated && !window.appEntityStore.isLocalResourceId( this.responseResourceId ) ){
    //We can remove listener now- only needed for getting server given ID
    window.appEventsEmitter.removeListener( "server-response", this.handleServerResponseListener );
    this.handleServerResponseListener = null;
  }
}





/**
 * Extract some useful info to handle what to do with resource
 * 
 * Need to remove in future, after better solution. Same method also in EventProcessor
 */
QuestionnaireHolder.prototype.extractBundleEntryMetaData = function( bundleEntry ) {
  var entryMeta = {
    'crudAction' : '',
    'crudActionResult' : false,
    'localReference' : '',
    'resourceId' : '',
    'responseCode' : ''
  }
  
  var requestMethod = '';
  if( typeof bundleEntry.request != 'undefined' ){
    requestMethod = bundleEntry.request.method;
  }

  var saveMethods = false;
  if( ( requestMethod == 'POST' || requestMethod == 'PUT') ){
    saveMethods = true;
  }

  if( typeof bundleEntry.response != 'undefined' ){
    var status = bundleEntry.response.status.substring( 0, 3 );
    var responseCode = parseInt( status );

    if( saveMethods ){
      entryMeta.crudAction = 'update_or_insert';
      entryMeta.crudActionResult = ( status == '201' );
    } else if ( status == '200' ){
      entryMeta.crudAction = 'read';
      entryMeta.crudActionResult = true;
    }

    if( responseCode > 0 ){
      entryMeta.responseCode = responseCode;
    }
  }
  
  if( typeof bundleEntry.request != 'undefined' ){
    requestMethod = bundleEntry.request.method;
  }


  if( typeof bundleEntry.resource != 'undefined' && typeof bundleEntry.resource.id != 'undefined' ){
    entryMeta.resourceId = bundleEntry.resource.id;
  }

  // find local reference link- by default it's server reference ID 
  entryMeta.localReference = entryMeta.resourceId;

  if( typeof bundleEntry.link != 'undefined' ){
    for( var i in bundleEntry.link ){
      var linkTest = bundleEntry.link[ i ];
        // 
      if( 
        typeof linkTest.url != 'undefined' && 
        typeof linkTest.relation != 'undefined' && 
        linkTest.relation == 'app'
      ){
        entryMeta.localReference = linkTest.url;  
      }

    }
  }

  return entryMeta;
}

QuestionnaireHolder.prototype.getCurrentQuestionnaireResponseResourceId = function() {
  return this.responseResourceId;
}


QuestionnaireHolder.prototype.getDebugAnswersList = function() {
  let list = [];

  for( var jj in this.answers ){
    if( this.answers[ jj ].answers.length > 0 ){


      let str = this.answers[ jj ].questionId + " answers are:: ";
      for( var ii in this.answers[ jj ].answers ){
        str = str + '' + this.answers[ jj ].answers[ ii ] + ", ";
      }

      list.push( str );
    }
  }

  console.log(  this.answers );

  return list;
}


QuestionnaireHolder.prototype.testRules = function() {
  console.log( "testRules::" );

  //var rules = test.parse( "(55:67A)+(63D)+(64D)+(<2(54,62,65,66)A)" );
  var rules = this.openerRulesParser.parse( "(1A)+(4D/NA)" );
  console.log( rules );
}


/**
 * get questionnaire resource in this holder
 * 
 * @param object resource
 */
QuestionnaireHolder.prototype.getOriginalResource = function( ) {
  return this.originalQuestionnaire;
};


/**
 * Diagnose questioner has complex rules which-on visibility of question or group is calculated
 * 
 */
QuestionnaireHolder.prototype.isItemVisibleByOpenerRules = function( questionOrGroup ) {

  var linkId = questionOrGroup.linkId ;
  //var fixedLinkId = this.openerRulesParser.fixQuestionLinkId( linkId );
  //console.log( 'this.answersFlatList:' );
  //console.log( this. );
  
  for( var i in this.rules ){
    
    if( this.rules[i].linkId == linkId ){
      var rule = this.rules[ i ].parsedJsonLogicString; // jsonLogic parsedJsonLogicString
      var boolResult = jsonLogic.apply(rule, this.answersFlatList );

      if( typeof boolResult === "boolean" ){
        
        //console.log('boolResult::'+boolResult + '(' + linkId + ')' );
        //console.log( JSON.stringify(rule) );
        //console.log( JSON.stringify(this.answersFlatList) );

        return boolResult;
      }
      
      //console.log( 'CHECK RULES MATCH FAILED::' + linkId + '::' + boolResult );
      //console.log( this.rules[ i ] );
      //console.log( this.answersFlatList );

      //fail safe return true if jsonLogic is not returning boolean
      return true;
    }
  }

  return true;
}


/**
 * Simple rule testing- later to be moved into it's own class, 
 * since not esponsibility for this class'. If there is more
 * 
 * Currently only "OR" so only one must match
 * 
 * @param object questionOrGroup
 */
QuestionnaireHolder.prototype.isItemVisible = function( questionOrGroup ) {

  if( typeof questionOrGroup.enableWhen != 'undefined' && questionOrGroup.enableWhen.length > 0 ){
    var show = false;
    for( var i in questionOrGroup.enableWhen ){

      var rule = questionOrGroup.enableWhen[ i ];
      var index = this.getAnswerRecordIndex( rule.question );
      var foundAnswer = -1;

      for( var j in this.answers[index].answers ){
        
        if( this.answers[index].answers[j] == rule.answerCoding.code ){
          foundAnswer = i;
        }
      }

      if( foundAnswer > -1 ){
        show = true;
      }

    }
    return show;
  }


  return true;
}


/**
 * Recursevly find opener rules from questionnaire json
 * 
 */
QuestionnaireHolder.prototype.getRulesFlatListForQuestionnaire = function( res ) {
  var rulesFound = [];

  if( res == null || typeof res.item == 'undefined' || res.item.length < 1 ){
    return rulesFound;
  }

  for( var i in res.item ){
    var ruleValueString = this.extractQuestionnaireItemExcelRule( res.item[i] );
    var ruleJson = this.extractQuestionnaireItemJsonRule( res.item[i] );
    
    // jsonLogic parsedJsonLogicString

    if( ruleValueString != '' || ruleJson ){
      try {
        var rule = {
          'linkId' : res.item[i].linkId,
          'ruleString' : ruleValueString,
          'parsedJsonLogicString' :  JSON.parse( ruleJson ),
          'jsonLogic' : ruleJson
        };
        rulesFound[ rulesFound.length ] = rule;
      } catch(err) {
        console.log( 'JSON was invalid for rule: ' );
        console.log( ruleJson );
      }
    }

    var subRules =  this.getRulesFlatListForQuestionnaire( res.item[i] );
    if( subRules.length > 0 ){
      rulesFound = rulesFound.concat( subRules );
    }

  }

  return rulesFound;
}


QuestionnaireHolder.prototype.parseAndExpandRules = function() {
  var parser = new OpenerRulesParser( this.originalQuestionnaire, this );
  var cache = new KeyValueCache();

  for( var i in this.rules ){

    // if( this.rules[ i ]. )

    var parsedCache = cache.get( this.rules[ i ].ruleString );
    if( parsedCache === null ){
      this.rules[ i ].parsedJsonLogicString = parser.parse( this.rules[ i ].ruleString );
      cache.set( this.rules[ i ].ruleString, this.rules[ i ].parsedJsonLogicString );
    } else {
      this.rules[ i ].parsedJsonLogicString = parsedCache;
    }
    
    this.rules[ i ].jsonLogic = JSON.stringify( this.rules[ i ].parsedJsonLogicString );
    //console.log( this.rules[ i ].ruleString );
    //console.log( this.rules[ i ].jsonLogic );
  }

  this.rawFuctionRulesList = parser.preprocessFunctionRules.getAllAsArray();

  var end_time = new Date().getTime();
}


/**
 * Set answering tips in current state to holder
 * Before closing questionnaire- these are pulled back and saved into state
 * 
 * @param object questionOrGroup
 * @param string comment
 * @return void
 */
QuestionnaireHolder.prototype.addCommentToQuestion = function( questionOrGroup, val ) {
  var questionId = questionOrGroup.linkId;
  
  var found = -1;

  for( var i in this.questionComments ){
    if( this.questionComments[i].questionId == questionId ){
      found = i;
    }
  }

  if( found < 0 ){
    this.questionComments[ this.questionComments.length ] = {
      'questionId' : questionId,
      'comment' : val
    };
  } else {
    this.questionComments[ found ].comment = val;
  }
}


/**
 * 
 * 
 * @param object question
 * @param string answer
 */
QuestionnaireHolder.prototype.isAnyAnswerPresent = function( question, answer ) {
  var questionId = question.linkId;
  var index = this.getAnswerRecordIndex( questionId );
  var found = -1;

  for( var i in this.answers[index].answers ){
    found = i;
  }

  if( found < 0 ){
    return false;
  } else {
    return true;
  }
  
};


/**
 * 
 * 
 * @param object question
 * @param string answer
 */
QuestionnaireHolder.prototype.isAnswerPresent = function( question, answer ) {
  var questionId = question.linkId;
  var index = this.getAnswerRecordIndex( questionId );
  var found = -1;

  for( var i in this.answers[index].answers ){
    
    if( this.answers[index].answers[i] == answer ){
      found = i;
    }
  }

  if( found < 0 ){
    return false;
  } else {
    return true;
  }
  
};


/**
 * if no content- remove it instead
 * 
 * @param object questionOrGroup
 * @param string comment
 * @return void
 */
QuestionnaireHolder.prototype.addOrUpdateCommentToAnswer = function( linkId, answerCode, comment ) {
  let questionId = linkId;
  
  var found = -1;

  for( var i in this.answerComments ){
    if( this.answerComments[i].questionId == questionId && this.answerComments[i].answerCode == answerCode ){
      found = i;
    }
  }

  // console.log( 'addOrUpdateCommentToAnswer : ' + linkId + ' / ' + answerCode + ' / ' + comment );

  if( found < 0 ){
    found = this.answerComments.length;
    this.answerComments[ found ] = {
      'questionId' : questionId,
      'answerCode' : answerCode,
      'comment' : comment
    };
  } else {
    this.answerComments[ found ].comment = comment;
  }

  if( ( comment == '' || !comment ) && found ){
    delete this.answerComments[ found ];
  }
  
  window.appEventsEmitter.emit( 'questionnaire-force-send-answers' );
}


/**
 * Used for Mental status answers - where client can add comment for each
 * 
 * @param object question
 * @param string answer
 */
QuestionnaireHolder.prototype.getAnswerComment = function( questionId, answerCode ) {

  for( var i in this.answerComments ){
    if( this.answerComments[i].questionId == questionId && this.answerComments[i].answerCode == answerCode ){
      return this.answerComments[i].comment;
    }
  }

  return '';
};


/**
 * Get all answer values present for given question
 * 
 * @param object question
 * @return array
 */
QuestionnaireHolder.prototype.getAllAnswersForQuestion = function( question ) {
  var questionId = question.linkId;
  var index = this.getAnswerRecordIndex( questionId );
  return this.answers[index].answers;
};


/**
 * 
 * 
 * @param object question
 * @param string answer
 */
QuestionnaireHolder.prototype.isAnswerPresent = function( question, answer ) {
  var questionId = question.linkId;
  var index = this.getAnswerRecordIndex( questionId );
  var found = -1;

  for( var i in this.answers[index].answers ){
    
    if( this.answers[index].answers[i] == answer ){
      found = i;
    }
  }

  if( found < 0 ){
    return false;
  } else {
    return true;
  }
  
};


/**
 * Apply QuestionnaireResponse resource on Questionnaire so answers there will pre-set 
 * all needed answers in here
 * 
 * @param object questionnaireResponse JSON
 * @param boolean
 */
QuestionnaireHolder.prototype.applyQuestionnaireResponseJson = function( questionnaireResponse ) {
  
  if( !questionnaireResponse || typeof questionnaireResponse.item == 'undefined' || questionnaireResponse.item.length < 1 ){
    return;
  }

  for( var i in questionnaireResponse.item ){
    var answerItem   = questionnaireResponse.item[ i ];
    var questionItem = this.findQuestionOrGroupByLinkId( this.originalQuestionnaire, answerItem.linkId );
    
    if( questionItem && typeof questionItem.type != 'undefined' && questionItem.type != 'group' && typeof questionItem.answerOption != 'undefined' ){
      for( var j in answerItem.answer ){
        
        if( typeof answerItem.answer[ j ].valueCoding != 'undefined' ){
          this.addAnswer( questionItem, answerItem.answer[ j ].valueCoding.code );
          
          // if comment added, add it also 
          if( 
            typeof answerItem.answer[ j ].extension != 'undefined' && 
            typeof answerItem.answer[ j ].extension[ 0 ] != 'undefined' && 
            answerItem.answer[ j ].extension[ 0 ].url == 'http://www.documental.ee/questionnaire-response-answer-comment'
          ){
            this.addOrUpdateCommentToAnswer( questionItem.linkId, answerItem.answer[ j ].valueCoding.code, answerItem.answer[ j ].extension[ 0 ].valueString );
          }
        }

      }
    }

    
    if( questionItem && typeof questionItem.type != 'undefined' && questionItem.type == 'boolean' ){
      for( var j in answerItem.answer ){
        if( typeof answerItem.answer[ j ].valueBoolean != 'undefined' && answerItem.answer[ j ].valueBoolean ){
          this.addAnswer( questionItem, true );
        }
      }
    }

    this.applyQuestionnaireResponseJson( answerItem );
  }
}


/**
 * 
 * 
 * @param object question
 * @param string answer
 */
QuestionnaireHolder.prototype.addAnswer = function( question, answer ) {
  var questionId = question.linkId;
  
  //answer can't be empty?
  if( answer  === null ){
    return;
  }

  // this.answers[i].answers
  var index = this.getAnswerRecordIndex( questionId );
  var found = -1;
  for( var i in this.answers[index].answers ){
    
    if( this.answers[index].answers[i] == answer ){
      found = i;
    }
  }
  
  if( found < 0 ){
    if( answer != '' ){
      // cant be empty - remove answers
      // console.log( 'Adding answer => ' + questionId + " => " +  answer );
      this.answers[index].answers[ this.answers[index].answers.length ] = answer;
    } else {
      // console.log( 'Adding answer:not added since empty answer provided. Only removed if where set => ' + questionId  );
    }
  } else {
    // console.log( 'Removing answer => ' + questionId + " => " +  answer );
    var ii = this.answers[index].answers.indexOf( answer );
    if(ii != -1) {
    	this.answers[index].answers.splice(ii, 1);
    }
  }

  this.updateOpenerRulesCache();
};


/**
 * update cache for rules matching
 */
QuestionnaireHolder.prototype.updateOpenerRulesCache = function() {

  var answersList = this.getAnswersAsCleanFlatList( this.originalQuestionnaire );

  this.answersFlatList = [];
  
  for( var i in answersList ){
    var q = answersList[ i ].linkId;
    q = this.openerRulesParser.fixQuestionLinkId( q );

    for( var j in answersList[ i ].answer ){
      var answer = answersList[ i ].answer[j];
      if( typeof answer.valueCoding != 'undefined' ){
        
        this.answersFlatList[ q ] = answer.valueCoding.code;


        // new LOGIC opener rules asin serverit nii, et nüüd on json-logic openerid tähisega "http://www.documental.ee/questionnaire-item-opener-json"
        let answrCode = this.openerRulesParser.fixQuestionLinkId(  answer.valueCoding.code );
        this.answersFlatList[ answrCode ] = true;


      } else if( typeof answer.valueBoolean != 'undefined' ) {
        //this.answersFlatList[ q ]  = answer.valueBoolean;


        //TODO: temporary hack for boolean questions @ 57A
        //we done have rules like 57true or 57false yet. We cast them to "A" instead like in excel
        //Needs re-visting
        if( answer.valueBoolean ){
          this.answersFlatList[ q ]  = 'A';
        }

      }
    }
  }


  var addRules = this.getCountFunctionExpandedRules2( this.rawFuctionRulesList );

  //console.log( 'CREATED_COUNTABLE_RULES: ' );
  //console.log( addRules );

  for( var k in addRules ){
    var check = addRules[ k ];
    this.answersFlatList[ check.valueKey ] = this.getCountFunctionResult( check );
  }

  
}


QuestionnaireHolder.prototype.getCountFunctionExpandedRules2 = function( inputList ) {
  var newAnswers = [];
  var parser = new CountFunctionParser();

  for( var i in inputList ){
    var parsed = parser.parse( inputList[i] );

    var more = -1;
    var less = 9999999999;

    if( parsed.equalTo != null ){
      more = parsed.equalTo -1;
      less = parsed.equalTo +1;
    }
    if( parsed.lessThan != null ){
      less = parsed.lessThan;
    }
    if( parsed.moreThan != null ){
      more = parsed.moreThan;
    }

    newAnswers[ newAnswers.length ] = {
      valueKey : i,
      countingRules : parsed.countables,
      hasMoreThan : more,
      hasLessThan : less
    };
  }

  return newAnswers;
}

/**
 * Some counts hardcoded currenlty
 * TODO: For demo needed- later to be modified to be dynamic
 * 
 * prepare functions also like "COUNT" as evaluated results of 1 or 0
 * These are special rules calculated before and only result is added into answers
 * 
 * checklist1:
 * COUNT_lbs__bs_4A_be___GT__1_lbe_
 * 
 * checklist2:
 * COUNT_lbs__bs_57A_be___GT__1_lbe_
 * COUNT_lbs__bs_54A_comma_62A_comma_66A_be___LT__2_lbe_
 * COUNT_lbs__bs_54A_comma_55A_comma_62A_comma__bs_63A_comma_64A_be__comma_65A_comma_66A_be___GT__2_lbe_
 * 
 * COUNT{(57A)>1}
 * COUNT{(54A,62A,66A)<2}
 * COUNT{(54A,55A,62A,(63A,64A),65A,66A)>2}
 * 
 * 
 * 
 * checklist3 - uued:
COUNT_lbs__bs_57_rbs_1_dash_12_rbe_A_be___GT__1_lbe_
COUNT{(57[1-12]A)>1}


COUNT_lbs__bs_54A_semi_55A_semi_62A_semi_63_slash_71A_semi_72A_semi_73A_be___GT__2_lbe_
COUNT{(54A;55A;62A;63/71A;72A;73A)>2} - TO BE DONE


COUNT_lbs__bs_63_rbs_1_dash_48_rbe_D_be__equals_48_lbe_
COUNT{(63[1-48]D)=48}

COUNT_lbs__bs_72_rbs_1_dash_2_rbe_D_be__equals_2_lbe_
COUNT{(72[1-2]D)=2}

COUNT_lbs__bs_54A_semi_62A_semi_73A_be___LT__2_lbe_
COUNT{(54A;62A;73A)<2}

 * 
 * 
 * checklist3:
 * COUNT_lbs__bs_99A_be___GT__1_lbe_
 * COUNT_lbs__bs_88A_comma_89A_comma_90A_comma_91A_comma_92A_comma_93A_comma_95A_comma_101A_be___GT__1_lbe_
 * 
 * COUNT_lbs__bs_89[8-11]A_comma_90A_comma_91A_comma_92A_be___GT__1_lbe_ -mind the []
 * COUNT_lbs__bs_96A_comma_97A_comma_98A_be___GT__1_lbe_
 * COUNT_lbs_92A_comma_93A_comma_94A_be___GT__3_lbe_
 * 
 * COUNT{(99A)>1}
 * COUNT{(88A,89A,90A,91A,92A,93A,95A,101A)>1}
 * 
 * COUNT{92A,93A,94A)>3}
 * COUNT{(96A,97A,98A)>1}
 * COUNT{(96A,97A,98A)>1+(99A)>1}
 * 
 */
QuestionnaireHolder.prototype.getCountFunctionExpandedRules = function( ) {
  var newAnswers = [];

  var splitted57A = [
    '57[1]A', '57[2]A', '57[3]A', '57[4]A',
    '57[5]A', '57[6]A', '57[7]A', '57[8]A',
    '57[9]A', '57[10]A', '57[11]A', '57[12]A'
  ];
  
  var splitted4A = [
    '4[2.1]A', '4[1]A', '4[2]A', '4[3]A',
    '4[4]A', '4[5]A', '4[6]A', '4[7]A',
    '4[9]A', '4[10]A', '4[11]A', '4[12]A', '4[13]A'
  ];
  
  var splitted63D = [];
  for ( var i = 1; i < 49; i++) { 
    splitted63D[ splitted63D.length ] = '63[' + i + ']D';
  }
  
  var splitted11D1_48 = [];
  for ( var i = 1; i < 49; i++) { 
    splitted11D1_48[ splitted11D1_48.length ] = '11[' + i + ']D';
  }


  var countRulesToCheck = [
    {
      valueKey : '',
      countables : splitted4A,
      hasMoreThan : 1,
      hasLessThan : 9999999999
    },
    {
      valueKey : 'COUNT_lbs__bs_57A_be___GT__1_lbe_',
      countingRules : splitted57A,
      hasMoreThan : 1,
      hasLessThan : 9999999999
    },
    {
      valueKey : 'COUNT_lbs__bs_57_rbs_1_dash_12_rbe_A_be___GT__1_lbe_',
      countingRules : splitted57A,
      hasMoreThan : 1,
      hasLessThan : 9999999999
    },
    {
      // COUNT{ (57[1;2;3;4;5;6;7;8;9;10]A) >1}
      valueKey : 'COUNT_lbs__bs_57_rbs_1_semi_2_semi_3_semi_4_semi_5_semi_6_semi_7_semi_8_semi_9_semi_10_rbe_A_be___GT__1_lbe_',
      countingRules : [ '57[1]A', '57[2]A', '57[3]A', '57[4]A', '57[5]A', '57[6]A','57[7]A','57[8]A','57[9]A','57[10]A' ],
      hasMoreThan : 1,
      hasLessThan : 9999999999
    },
    {
      valueKey : 'COUNT_lbs__bs_54A_comma_62A_comma_66A_be___LT__2_lbe_',
      countingRules : ['54A', '62A', '66A'],
      hasMoreThan : -1,
      hasLessThan : 2
    },
    {
      valueKey : 'COUNT_lbs__bs_54A_comma_55A_comma_62A_comma__bs_63A_comma_64A_be__comma_65A_comma_66A_be___GT__2_lbe_',
      countingRules : ['54A', '55A', '62A', '(63A),(64A)', '65A', '66A'],
      hasMoreThan : 2,
      hasLessThan : 9999999999
    },
    {
      // COUNT{(54A,55A,62A,(63/71A),72A,73A)>2}
      valueKey : 'COUNT_lbs__bs_54A_comma_55A_comma_62A_comma__bs_63_slash_71A_be__comma_72A_comma_73A_be___GT__2_lbe_',
      countingRules : ['54A', '55A', '62A', '(63A),(64A)', '65A', '66A'],
      hasMoreThan : 2,
      hasLessThan : 9999999999
    },

    {
      valueKey : 'COUNT_lbs__bs_88A_comma_89A_comma_90A_comma_91A_comma_92A_comma_93A_comma_95A_comma_101A_be___GT__1_lbe_',
      countingRules : ['88A', '89A', '90A', '91A', '92A', '93A', '95A', '101A'],
      hasMoreThan : 1,
      hasLessThan : 9999999999
    },
    {
      valueKey : 'COUNT_lbs__bs_99A_be___GT__1_lbe_',
      countingRules : ['99A'],
      hasMoreThan : 1,
      hasLessThan : 9999999999
    },
    {
      valueKey : 'COUNT_lbs__bs_54A_semi_62A_semi_73A_be___LT__2_lbe_',
      countingRules : ['54A', '62A', '73A'],
      hasMoreThan : -1,
      hasLessThan : 2
    },
    {
      valueKey : 'COUNT_lbs__bs_54A_comma_62A_comma_73A_be___LT__2_lbe_',
      countingRules : ['54A', '62A', '73A'],
      hasMoreThan : -1,
      hasLessThan : 2
    },
    {
      valueKey : 'COUNT_lbs__bs_63_rbs_1_dash_48_rbe_D_be__equals_48_lbe_',
      countingRules : splitted63D,
      hasMoreThan : 47,
      hasLessThan : 49
    },
    {
      valueKey : 'COUNT_lbs__bs_72_rbs_1_dash_2_rbe_D_be__equals_2_lbe_',
      countingRules : ['72[1]D', '72[2]D'],
      hasMoreThan : 1,
      hasLessThan : 3
    },


    // new ones 

    // COUNT{(5[1-12]A)>1} key: COUNT_lbs__bs_5_rbs_1_dash_12_rbe_A_be___GT__1_lbe_
    {
      valueKey : 'COUNT_lbs__bs_5_rbs_1_dash_12_rbe_A_be___GT__1_lbe_',
      countingRules : [
        '5[1]A', '5[2]A', '5[3]A', '5[4]A', '5[5]A', '5[6]A', '5[7]A', '5[8]A',
        '5[9]A', '5[10]A', '5[11]A', '5[12]A'
      ],
      hasMoreThan : 1,
      hasLessThan : 9999999999
    },

    // COUNT{(11[1-48]D)=48} key: COUNT_lbs__bs_11_rbs_1_dash_48_rbe_D_be__equals_48_lbe_
    {
      valueKey : 'COUNT_lbs__bs_11_rbs_1_dash_48_rbe_D_be__equals_48_lbe_',
      countingRules : splitted11D1_48,
      hasMoreThan : 47,
      hasLessThan : 49
    },

    // COUNT {(2A; 10A; 21A)<2} key: COUNT_lbs__bs_2A_semi_10A_semi_21A_be___LT__2_lbe_
    {
      valueKey : 'COUNT_lbs__bs_2A_semi_10A_semi_21A_be___LT__2_lbe_',
      countingRules : [ '2A', '10A', '21A' ],
      hasMoreThan : -1,
      hasLessThan : 2
    },

    // COUNT  {(20[1-2]D)=2} key: COUNT_lbs__bs_20_rbs_1_dash_2_rbe_D_be__equals_2_lbe_
    {
      valueKey : 'COUNT_lbs__bs_20_rbs_1_dash_2_rbe_D_be__equals_2_lbe_',
      countingRules : [ '20[1]D', '20[2]D' ],
      hasMoreThan : 1,
      hasLessThan : 3
    },

    // COUNT {(2A; 3A; 10A; 11/19A; 20A; 21A) > 2}
    // key: COUNT_lbs__bs_2A_semi_3A_semi_10A_semi_11_slash_19A_semi_20A_semi_21A_be___GT__2_lbe_
    {
      valueKey : 'COUNT_lbs__bs_2A_semi_3A_semi_10A_semi_11_slash_19A_semi_20A_semi_21A_be___GT__2_lbe_',
      countingRules : [ '2A', '3A', '10A', '(11A),(19A)', '20A', '21A' ],
      hasMoreThan : 2,
      hasLessThan : 9999999999
    },
  ];

  return countRulesToCheck;
}


/**
 * Countung rules need some pre-proccessing of rules to be added into answers list
 * 
 * Input object is something following: 
 * {
 *    valueKey : 'COUNT_lbs__bs_2A_semi_3A_semi_10A_semi_11_slash_19A_semi_20A_semi_21A_be___GT__2_lbe_',
 *    countingRules : [ '2A', '3A', '10A', '(11A),(19A)', '20A', '21A' ],
 *    hasMoreThan : 2,
 *    hasLessThan : 9999999999
 *  }
 * 
 * Basically we evaluate each rule in countingRules array. If true the count is increased. 
 * Finally we check count against hasMoreThan and hasLessThan attributes to determine is overall 
 * count expression true or false. 
 * 
 * Result will pe injected into answers list. 
 * 
 */
QuestionnaireHolder.prototype.getCountFunctionResult = function( check ) {
  var result = 0;
  var matchesCount = 0;
  var parser = new OpenerRulesParser( this.originalQuestionnaire, this );
  
  for( var j in check.countingRules ){

    var rule = parser.parse( check.countingRules[ j ] );
    var boolResult = jsonLogic.apply(rule, this.answersFlatList );
    
    //console.log( 'rule: ' + check.countingRules[ j ] + '=>'+ boolResult );
    //console.log( rule );

    if( typeof boolResult === "boolean" ){
      if( boolResult ){
        matchesCount++;
      }
    }

  }

  if( matchesCount > check.hasMoreThan && matchesCount < check.hasLessThan ){
    result = 1;
  }

  return result;
}


/**
 * Return index of the correct answer bundle/record
 * If not present - create one and return its new index
 * 
 * @param string questionId
 */
QuestionnaireHolder.prototype.getAnswerRecordIndex = function( questionId ) {
  
  for( var i in this.answers ){
    if( this.answers[i].questionId == questionId ){
      return i;
    }
  }

  var newAnswerEntry = {
    'questionId' : questionId,
    'answers' : [ ]
  }
  
  this.answers[ this.answers.length ] = newAnswerEntry;

  for( var i in this.answers ){
    if( this.answers[i].questionId == questionId ){
      return i;
    }
  }

  return -1;
};



/**
 * Do this recoursevly just in case- since one question can open up another- and so on. 
 * 
 * @param object question
 * @param string answer
 */
QuestionnaireHolder.prototype.clearAnswersForQuestion = function( linkId ) {
  var someAnswersRemoved = false;

  var index = this.getAnswerRecordIndex( linkId );
  for( var i in this.answers[index].answers ){
    //clearAnswersForQuestion = function( linkId )  
    //.isItemVisible( item )
    console.log( "Removed answer in clearAnswersForQuestion: " + i );
    delete this.answers[index].answers[i];
    someAnswersRemoved = true;
  }
  this.answers[index].answers = [];
  
  var test  = this.clearAnswersForDependableQuestions( this.originalQuestionnaire.item );
  var test2 = this.clearAnswersForDependableQuestions( this.originalQuestionnaire.item );

  
  if( someAnswersRemoved || test || test2 ){
    this.updateOpenerRulesCache();
    someAnswersRemoved = true;
    setTimeout( function(){
      console.log( "Emitted answer-remove from clearAnswersForQuestion" );
      window.appEventsEmitter.emit( 'check-items-visibility' );
      window.appEventsEmitter.emit( 'answer-remove-called' );
    }, 300 );
  }

  return someAnswersRemoved;
}



/**
 * Almost smae as clearAnswersForQuestion, but removed only given and does not emit anything
 * 
 * @param object question
 * @param string answer
 */
QuestionnaireHolder.prototype.clearAnswersForQuestionOnlyWithoutEmitting = function( linkId ) {
  var someAnswersRemoved = false;

  var index = this.getAnswerRecordIndex( linkId );
  for( var i in this.answers[index].answers ){
    //clearAnswersForQuestion = function( linkId )  
    //.isItemVisible( item )
    console.log( "Removed answer in clearAnswersForQuestionOnlyWithoutEmitting: " + i );
    delete this.answers[index].answers[i];
    someAnswersRemoved = true;
  }
  this.answers[index].answers = [];
  
  return someAnswersRemoved;
}


/**
 * Find any questions that might be influenced by current question answer
 * If one questions answers are changed some question could be shown/hidden based on that 
 * It's related to enableWhen rules found in questionnaire. Remove all answers 
 * if "parent" question is removed  
 * 
 */
QuestionnaireHolder.prototype.clearAnswersForDependableQuestions = function( items ) {
  var someAnswersRemoved = false;
  for( var i in items ){


    if( ! this.isItemVisible( items[ i ] ) ){
      var linkId = items[ i ].linkId;
      var index = this.getAnswerRecordIndex( linkId );
      for( var j in this.answers[index].answers ){
        console.log( "Removed answer: " + j );
        delete this.answers[index].answers[j];
        someAnswersRemoved = true;
      }
      this.answers[index].answers = [];
    }


    if( typeof items[ i ].item != 'undefined' && items[ i ].item.length > 0 ){    
      var test = this.clearAnswersForDependableQuestions( items[ i ].item );
      if( test ){
        someAnswersRemoved = true;
      }
    }
  }

  if( someAnswersRemoved ){
    window.appEventsEmitter.emit( 'answer-remove-called' );
  }

  return someAnswersRemoved;
}


/**
 * 
 * 
 * @return QuestionnaireResponse
 */
QuestionnaireHolder.prototype.getCurrentQuestionnaireResponse = function( ) {
  if( this.originalQuestionnaire == null ){
    return null;
  }

  //TODO: var creator = new QuestionnaireResponseCreator();
  var questionnaireResponseObject = new QuestionnaireResponse( );
  
  questionnaireResponseObject.item = this.getAnswersToResponse( this.originalQuestionnaire );

  var sourceReference = this.getOriginalReferenceForResponse( this.originalQuestionnaire );
  questionnaireResponseObject.setSourceQuestionnaireResource( sourceReference );

  return questionnaireResponseObject;
};


/**
 * -
 * 
 * @return Reference
 */
QuestionnaireHolder.prototype.getOriginalReferenceForResponse = function( res ) {
  var ref = new Reference();
  
  ref.setLiteralReference( res.url, res.title );
  return ref;
}


/**
 * In diagnose questionnaire we wan't to get possible diagnose list at initial load
 * By making "Empty" answer sending to server which results in possible diagnoses
 * 
 * Also make this call when loading already started questinnaire when 
 * QuestionnaireResponse is applied on top (how to dedect it?) - lets just load for every 
 * time at moment. 
 * 
 * This is needed to load reccomendations and diagnoses immidately after Questionnaire is opened
 * 
 * @return boolean
 */
QuestionnaireHolder.prototype.sendAnswersImmediately = function( ) {

  if( this.getToolType() == 'diagnose-validation' ){
    return true;
  }
  
  return true;
  //return false;
}


/**
 * 
 * @return boolean
 */
QuestionnaireHolder.prototype.showRecommendations = function( ) {

  if( this.getToolType() == 'assessment' ){
    return true;
  }
  
  return false;
}


/**
 * 
 * @return boolean
 */
QuestionnaireHolder.prototype.showCompletion = function( ) {
  var type = this.getToolType();

  if( type == 'diagnose-validation' || type == 'assessment' ){
    return true;
  }
  
  return false;
}


/**
 * Is current questionnaire a 
 *   - assessment
 *   - diagnose-validation
 * 
 * @return boolean
 */
QuestionnaireHolder.prototype.getToolType = function( ) {
  
  if( typeof this.originalQuestionnaire.extension != 'undefined' && this.originalQuestionnaire.extension.length > 0 ){
    for( var i in this.originalQuestionnaire.extension ){
      var extension = this.originalQuestionnaire.extension[ i ];

      if( extension.url == 'http://www.documental.ee/tool-type' ){
        return extension.valueCoding.code;
      }
    }
  }

  return '';
}


/**
 * Get answers recursive-ly in original Questionnaire hierarchy
 * 
 * @return Array
 */
QuestionnaireHolder.prototype.getAnswersToResponse = function( res ) {
  var returnItems = [];

  // nothing to return anymore
  if( res == null || typeof res.item == 'undefined' || res.item.length < 1 ){
    return returnItems;
  }

  //Let's get recursive until no childs present
  for( var i in res.item ){
    var obj = {};
    obj.linkId = res.item[i].linkId;
    obj.text   = res.item[i].text;
    obj.item = this.getAnswersToResponse( res.item[i] );


    var foundComment = -1;
    var commentContent = "";
    for( var i in this.questionComments ){
      if( this.questionComments[i].questionId == obj.linkId ){
        if( this.questionComments[i].comment ){
          foundComment = i;
          commentContent = this.questionComments[i].comment;
        }
      }
    }

    if( foundComment > -1 ){
      obj.extension = [
        {
          "url" : "http://www.documental.ee/questionnaire-response-item-comment",
          "valueString" : commentContent
        }
      ];
    }


    //if question- not group. Add answer(s) also
    //if( res.item[i].type != 'group' && res.item[i].type != 'visual-group'  ){
      //TODO: is this correct? Shouldn't here be another level on "value"? Check later
      obj.answer = this.getAnswerResponseObjectByLinkId( obj.linkId );
      
      if( typeof res.item[i].type != 'undefined' && res.item[i].type == 'boolean' ){
        //booleans should always have answer
        if( obj.answer.length < 1 ){
          //obj.answer =  [{
          //  "valueBoolean": false
          //}];
        }
      }

      if( obj.answer.length < 1 ){
        delete obj.answer;
      }
    //}
    
    if( obj.item.length < 1 ){
      delete obj.item;
    }

    returnItems[ returnItems.length ] = obj;
  }

  return returnItems;
}


/**
 * 
 * @param string questionId
 */
QuestionnaireHolder.prototype.getAnswerResponseObjectByLinkId = function( linkId ) {
  var answers = [];
  var index = this.getAnswerRecordIndex( linkId );

  for( var i in this.answers[index].answers ){
    var answerItem = {
    };

    let answerCodeForComment = '';

    //TODO: Better solution for this hardcoded part here.. question types should be intruduced
    //which can create response answers their own. This method should not know about question types and how they are reprenseted
    var foundOriginalItem = this.findQuestionOrGroupByLinkId( this.originalQuestionnaire, linkId );
    var answerValue = this.answers[index].answers[i];

    if( foundOriginalItem.type == "choice" ){
      //they have valueCodings
      answerItem.valueCoding = {
        code : answerValue
      }
      answerCodeForComment = answerValue;
    }

    if( foundOriginalItem.type == "boolean" ){
      answerItem.valueBoolean = answerValue;
      //"valueBoolean": true,
    }


    if( foundOriginalItem.type == "text" || foundOriginalItem.type == "string" ){
      answerItem.valueString = answerValue;
    }
    

    // mental statuses have possibility to comment selected answer - add them
    let commentContent = '';
    if( answerCodeForComment ){
      commentContent = this.getAnswerComment( linkId, answerCodeForComment );
    }

    if( commentContent != '' && commentContent ){
      answerItem.extension = [
        {
          "url" : "http://www.documental.ee/questionnaire-response-answer-comment",
          "valueString" : commentContent
        }
      ];
    }
    
    answers[ answers.length ] = answerItem;
  }

  return answers;
}


/**
 * 
 * 
 * @return Array
 */
QuestionnaireHolder.prototype.getAnswersFlatList = function() {
  return this.getAnswersAsCleanFlatList( this.originalQuestionnaire );
}


/**
 * Get answers recursive-ly in a list. No original hierarchy added. 
 * Remove empty groups and questions (without answer). 
 * 
 * @return Array
 */
QuestionnaireHolder.prototype.getAnswersAsCleanFlatList = function( res ) {

  var returnItems = [];

  // nothing to return anymore
  if( res == null ){
    return returnItems;
  }

  let isSelfReport = false;
  if( typeof res.linkId != 'undefined' && res.linkId.indexOf('SR.') > -1 ){
    isSelfReport = true;
  }

  
  // special self-report-v1 case. Check it's not self-report-v1 
  // questonnaire (determined by link ID beginnings with "SR." ). If it is 
  // answers here are actually treated as questions
  /* 
  if( isSelfReport && typeof res.answerOption != 'undefined' && res.answerOption.length > 0 ){
    for( var j in res.answerOption ){
      
      if( typeof res.answerOption[ j ].valueCoding != 'undefined' && res.answerOption[ j ].valueCoding.code != 'undefined' ){
        
        var obj = {};
        obj.linkId = res.answerOption[ j ].valueCoding.code;
        obj.text   = res.answerOption[ j ].valueCoding.display;
        obj.answer = [];
        let tmpAanswers = this.getAnswerResponseObjectByLinkId( res.linkId );
        
        if( tmpAanswers.length > 0 ){
          for( var k in tmpAanswers ){
            
              if( 
                typeof tmpAanswers[ k ].valueCoding != 'undefined' && 
                tmpAanswers[ k ].valueCoding.code != 'undefined' && 
                tmpAanswers[ k ].valueCoding.code == res.answerOption[ j ].valueCoding.code
              ){

                // create fake question / answer with A answer
                obj.answer = [ {
                    "valueCoding" :  {
                      "code" : "A"
                    }
                  }
                ];

              }
          }
        }
        
        if( obj.answer.length > 0 ){
          returnItems[ returnItems.length ] = obj;
        }
      }
    }
  }
  */


  // nothing to return anymore
  if( typeof res.item == 'undefined' || res.item.length < 1 ){
    return returnItems;
  }

  //Let's get recursive until no childs present
  for( var i in res.item ){
    var obj = {};
    obj.linkId = res.item[i].linkId;
    obj.text   = res.item[i].text;
    
    obj.answer = this.getAnswerResponseObjectByLinkId( obj.linkId );
    
    if( typeof res.item[i].type != 'undefined' && res.item[i].type == 'boolean' ){
      //booleans should always have answer?
      if( obj.answer.length < 1 ){
        //obj.answer =  [{
        //  "valueBoolean": false
        //}];
      }
    }

    if( obj.answer.length > 0 ){
      returnItems[ returnItems.length ] = obj;
    }

    //add childs into list
    var subItems = this.getAnswersAsCleanFlatList( res.item[i] );
    for( var j in subItems ){
      returnItems[ returnItems.length ] = subItems[ j ];
    }
  }

  return returnItems;
}


/**
 * 
 * @param string questionId
 */
QuestionnaireHolder.prototype.questionGroupAllVisibleAnswered = function( questionId ) {
  // find the correct group/question
  var foundGroup = this.findQuestionOrGroupByLinkId( this.originalQuestionnaire, questionId );

  for( var i in foundGroup.item ){
    var visible = this.isItemVisible( foundGroup.item[i] );
    if( visible ){
      var index = this.getAnswerRecordIndex( foundGroup.item[i].linkId );
      if( index > -1 ){
        return true;
      }
    }
    
  }

  return false;
};


/**
 * 
 * 
 * @param string linkId
 */
QuestionnaireHolder.prototype.findQuestionOrGroupByLinkId = function( qitem, linkId ) {
  
  if( typeof qitem.linkId != 'undefined' && qitem.linkId == linkId ){
    return qitem;
  }

  if( typeof qitem.item != 'undefined' && qitem.item.length > 0 ){
    for( var i in qitem.item ){
      var test = this.findQuestionOrGroupByLinkId( qitem.item[i], linkId );
      if( test != null ){
        return test;
      }
    }
  }

  return null;
};


/**
 * Return first level questionnaire items (used as tabs)
 * Don't include completion part- it's handled separately. 
 * 
 * @param object questionnaire
 */
QuestionnaireHolder.prototype.getTabItems = function( ) {
  
  var tabs = [];
  
  for( var i in this.originalQuestionnaire.item ){
    
    //if firt level group is extended, it's not a tab (TODO: hardcoded logic currently)'
    var extended = false;
    if( typeof this.originalQuestionnaire.item[ i ].extension != 'undefined' && this.originalQuestionnaire.item[ i ].extension.length > 0 ){
      extended = true;
      // "url" : "http://www.documental.ee/questionnaire-group-completion"
    }

    if( !extended ){
      tabs[ tabs.length] = this.originalQuestionnaire.item[ i ];
    }
  }

  //add special diagnose tab for diagnose checklist questionnaire
  if( this.getToolType() == 'diagnose-validation' ){
    var diagnoseTab = {
      'linkId' : 'systemDiagnoseTab',
      'text' : 'Diagnoses',
      'item' : [],
    }

    tabs[ tabs.length] = diagnoseTab;
  }

  return tabs;
};



/**
 * Return completion part of the questionnaire
 * 
 * @param object questionnaire
 */
QuestionnaireHolder.prototype.getCompletionItems = function( ) {
  
  var completionItems = [];
  var found = false;

  for( var i in this.originalQuestionnaire.item ){
    if( this.isItemCompletionGroup( this.originalQuestionnaire.item[ i ] ) ){
      found = true;
      completionItems = this.originalQuestionnaire.item[ i ].item;
    }
  }
  
  return completionItems;
};


/**
 * On first level there could be (tab) item that is actually grouping  
 * completions items. 
 * 
 * TODO: needs to be moved out of this class - also used 
 * in QuestionnaireResponseSummary.isItemCompletionGroup
 * 
 * @param object questionnaire item
 * @return boolean
 */
QuestionnaireHolder.prototype.isItemCompletionGroup = function( item ) {
  
  var isCompletion = false;

  if( typeof item.extension != 'undefined' && item.extension.length > 0 ){
    for( var i in item.extension ){
      var extension = item.extension[ i ];

      if( extension.url == 'http://www.documental.ee/questionnaire-group-completion' ){
        isCompletion = true;
      }
    }
  }

  return isCompletion;
}


/**
 * Load answer hints from resource "conceptmap-questionnaire-item-map"
 * 
 * window.appEntityStore.getEntityByEntityId( 'conceptmap-questionnaire-item-map' )
 * 
 * @return AnswerHintsFromMentalStatus
 */
QuestionnaireHolder.prototype.loadAnswerHintRules = function() {
  let answerHints = new AnswerHintsFromMentalStatus();

  let cm = window.appEntityStore.getEntityByEntityId( 'conceptmap-questionnaire-item-map' )

  if( cm == null || !cm ){
    return null;
  }

  answerHints.addRulesFromConceptMap( cm );

  return answerHints;
}


/**
 * Generate answer hints based on given QuestionnaireResponses with correct statuses
 * 
 * @param array questionnaireResponses
 * @return void
 */
QuestionnaireHolder.prototype.generateAnswerHintsFromQuestionnaireResponses = function( questionnaireResponses ) {
  this.answerHints = this.loadAnswerHintRules();

  //console.log( 'answerHints::' );
  //console.log( this.answerHints.getCachedHints() );
  //this.answerHints.clearAnswersCacheForQuestionnaire( '' );

  // read hints from responses with status of "in-progress" or "completed"
  // favor for newer and "completed"
  let foundIndex = -1;
  for( var i in questionnaireResponses ){
    let qrJson = questionnaireResponses[ i ].toObject();
    if( qrJson.questionnaire ==  "Questionnaire/assessment-mental-status-v1" ){

      if( questionnaireResponses[ i ].getStatus() == 'completed' ){
        foundIndex = i;
      }

      if( questionnaireResponses[ i ].getStatus() == 'in-progress' && foundIndex < 0 ){
        foundIndex = i;
      }
    }
  }

  if( foundIndex < 0 ){
    return;
  }

  let qrJson = questionnaireResponses[ foundIndex ].toObject();
  let flatList = this.createAnsersFlatListFromQuestionnaireResponseJson( qrJson );
  
  let tmp = [];
  for( var k in flatList ){
    tmp.push( flatList[ k ].answerCode );
  }
  this.answerHints.addAnswers( qrJson.questionnaire, tmp );
}


QuestionnaireHolder.prototype.initInitialValues = function() {
  if( !this.answerHints || this.answerHints === null ){
    return;
  }

  let hints = this.answerHints.getCachedHints();

  for( var i in hints ){
    var questionItem = this.findQuestionOrGroupByLinkId( this.originalQuestionnaire, hints[ i ].getDestinationId() );
    if( questionItem ){
      if( questionItem.type == 'boolean' ){
        this.addAnswer( questionItem, hints[ i ].getValueBoolean() );
      } else {
        this.addAnswer( questionItem, hints[ i ].getValueString() );
      }
    }
  }

}


/**
 * 
 * 
 * @param object qrJson 
 */
QuestionnaireHolder.prototype.createAnsersFlatListFromQuestionnaireResponseJson = function( qrJson ) {
  let answersFlatList = [];

  if( !qrJson || typeof qrJson == 'undefined' ){
    return answersFlatList;
  }

  if( typeof qrJson.answer != 'undefined' && qrJson.answer.length > 0 ){
    
    for ( var j in qrJson.answer ){
      if( typeof qrJson.answer[ j ].valueCoding != 'undefined' && typeof qrJson.answer[ j ].valueCoding.code != 'undefined' ){
        answersFlatList.push( {
          linkId : qrJson.linkId,
          answerCode : qrJson.answer[ j ].valueCoding.code
        } );
      }
    }
  }

  if( typeof qrJson.item != 'undefined' ){
    for( var i in qrJson.item ){
      let tempList = this.createAnsersFlatListFromQuestionnaireResponseJson( qrJson.item[ i ] );
      if( tempList.length > 0 ){
        answersFlatList = answersFlatList.concat( tempList );
      }
    }
  }

  return answersFlatList;
}


/**
 * Apply QuestionnaireResponse resource on Questionnaire so answers there will pre-set 
 * all needed answers in here
 * 
 * @param object questionnaireResponse JSON
 * @param boolean
QuestionnaireHolder.prototype.applyQuestionnaireResponseJson = function( questionnaireResponse ) {
  
  if( !questionnaireResponse || typeof questionnaireResponse.item == 'undefined' || questionnaireResponse.item.length < 1 ){
    return;
  }

  for( var i in questionnaireResponse.item ){
    var answerItem   = questionnaireResponse.item[ i ];
    var questionItem = this.findQuestionOrGroupByLinkId( this.originalQuestionnaire, answerItem.linkId );
    
    if( questionItem && typeof questionItem.type != 'undefined' && questionItem.type != 'group' && typeof questionItem.answerOption != 'undefined' ){
      for( var j in answerItem.answer ){
        
        if( typeof answerItem.answer[ j ].valueCoding != 'undefined' ){
          this.addAnswer( questionItem, answerItem.answer[ j ].valueCoding.code );
          
          // if comment added, add it also 
          if( 
            typeof answerItem.answer[ j ].extension != 'undefined' && 
            typeof answerItem.answer[ j ].extension[ 0 ] != 'undefined' && 
            answerItem.answer[ j ].extension[ 0 ].url == 'http://www.documental.ee/questionnaire-response-answer-comment'
          ){
            this.addOrUpdateCommentToAnswer( questionItem.linkId, answerItem.answer[ j ].valueCoding.code, answerItem.answer[ j ].extension[ 0 ].valueString );
          }
        }

      }
    }

    
    if( questionItem && typeof questionItem.type != 'undefined' && questionItem.type == 'boolean' ){
      for( var j in answerItem.answer ){
        if( typeof answerItem.answer[ j ].valueBoolean != 'undefined' && answerItem.answer[ j ].valueBoolean ){
          this.addAnswer( questionItem, true );
        }
      }
    }

    this.applyQuestionnaireResponseJson( answerItem );
  }
}
 */


/**
 * 
 * 
 * @param object questionnaire item link id
 * @return string
 */
QuestionnaireHolder.prototype.getAnswerHintForLinkId = function( itemLinkId ) {
  
  if( this.answerHints == null ){
    return new AnswerHint( false );
  }
  
  var rHint = this.answerHints.findHintByQuestionId( itemLinkId );
  
  if( rHint.hintFound() ){
    // rHint.setHintComment( 'Answer hinted from ID: ' + rHint.getSourceId() );
    rHint.setHintComment( 'Answer hint are marked with light green color' );
  }

  return rHint;
}


/**
 * Hold currently active tab index in memory. Used when checking off tabs that 
 * are done @ quoestionnaire results/completion part 
 * 
 * @param integer tabNumber
 * @param string  linkId
 */
QuestionnaireHolder.prototype.setActiveTab = function( tabNumber, linkId ) {
  this.activeTabNumber = tabNumber;
  this.activeTabLinkId = linkId;
  console.log( 'Set active tab index: ' + tabNumber + ' (' + linkId + ')' );
  window.appEventsEmitter.emit( 'questionnaire-force-send-answers' );
};


/**
 * Set active content tab when questionnaire firt loaded
 * 
 * @return void
 */
QuestionnaireHolder.prototype.setFirstContentTabActive = function() {
  var questionnaireTabs = this.getTabItems();
  var tabCounter = 0;

  for( var i in questionnaireTabs ){
    tabCounter++;
    if( tabCounter == 1 ){
      this.setActiveTab( tabCounter, questionnaireTabs[ i ].linkId );
      return;
    }
  }
};


/**
 * -
 * 
 * @return integer
 */
QuestionnaireHolder.prototype.getActiveTabNumber = function( ) {
  return this.activeTabNumber;
};


/**
 * -
 * 
 * @return string
 */
QuestionnaireHolder.prototype.getActiveTabLinkId = function( ) {
  return this.activeTabLinkId;
};


/**
 * 
 * Currently just return opener rule as string like "1A+4A" and such
 * Some punctations gets leaked past server API like "." - this must be "" which means no rules
 * 
 * @param Object groupOrQuestion
 * @return string
 */
QuestionnaireHolder.prototype.extractQuestionnaireItemExcelRule = function( groupOrQuestion ) {
  var rule = '';

  if( typeof groupOrQuestion.extension != 'undefined' && groupOrQuestion.extension.length > 0 ){
    for( var i in groupOrQuestion.extension ){
      if( groupOrQuestion.extension[i].url == 'http://www.documental.ee/questionnaire-item-opener-rule' ){
        rule = groupOrQuestion.extension[i].valueString;
        rule = rule.trim();
      }
    }
  }

  if( rule == '.' || rule == '..' ){
    return '';
  }
  
  //if( this.originalQuestionnaire.id == "self-report-v1" ) {
    // self report questionnaire needs to fix lowercase to uppercase A-s
    rule = rule.replace( ']a', ']A' );
    rule = rule.replace( ']a', ']A' );
    rule = rule.replace( ']a', ']A' );
  //}
  
  return rule;
};



/**
 * @param Object groupOrQuestion
 * @return string
 */
QuestionnaireHolder.prototype.extractQuestionnaireItemJsonRule = function( groupOrQuestion ) {
  var rule = '';

  if( typeof groupOrQuestion.extension != 'undefined' && groupOrQuestion.extension.length > 0 ){
    for( var i in groupOrQuestion.extension ){
      if( groupOrQuestion.extension[i].url == 'http://www.documental.ee/questionnaire-item-opener-json' ){
        rule = groupOrQuestion.extension[i].valueString;
        rule = rule.trim();
      }
    }
  }

  return rule;
};


/**
 * Update other questions in given group if restrictions are there (E,S,U,M) @ 
 * http://www.documental.ee/questionnaire-answer-set
 * 
 * Also interpret "ez" as "e" grouping. ez was needed by backend and not in frontend. 
 * But still means that it must be uniqe question answered in group
 * Some others found that need no conversion: 
 *    z  => z
 *    z1 => z1
 *    z2 => z2
 * 
 * @param object answeredQuestion - question that was changed
 * @param boolean value - answer selected for question that was changed
 * @param object questionOrGroup - in which group answered question was
 * @param boolean
 */
QuestionnaireHolder.prototype.updateDiagnoseCheckboxes = function( answeredQuestion, value, questionOrGroup ) {

  var restrictionGroup = this.extractQuestionRestrictionExtension( answeredQuestion );
  if( !value || !restrictionGroup.found ){
    return;
  }
  
  //U goes with almost everything. - temporary fix @ checklist 2. TODO: 
  if( restrictionGroup.grouping == 'u' ){
    return false;
  }

  if( restrictionGroup.grouping == "ez" ){
    restrictionGroup.grouping = 'e';
  }
  
  var changed = false;

  for( var i in questionOrGroup.item ){
    var linkId = questionOrGroup.item[i].linkId;
    var test = this.extractQuestionRestrictionExtension( questionOrGroup.item[i] );
    var sameQuestion = ( linkId == answeredQuestion.linkId );
    
    if( test.grouping == "ez" ){
      test.grouping = 'e';
    }

    if( test.found && test.grouping == restrictionGroup.grouping && !sameQuestion ){
      changed = true;
      this.clearAnswersForQuestion( linkId );
    }
  }

  if( changed ){
    this.updateOpenerRulesCache();
  }

  return changed;  
}


/**
 * This is related to different answer restrictions in options
 * Extension that states this rules is http://www.documental.ee/questionnaire-question-set
 * but currently server uses http://www.documental.ee/questionnaire-answer-set as that. 
 * So basically we can use same fuction as for options in mental status
 * 
 * Currently just return which restriction typ it is (E,S,U,M)
 * And if there is a additional number - return that too for grouping correct questions
 * 
 * @return string
 */
QuestionnaireHolder.prototype.extractQuestionRestrictionExtension = function( question ) {
  var letter = this.extractOptionRestrictionExtension( question );

  var found = letter.length > 0;

  if( found ){
    return {
      found: true,
      ruleLetter: letter.substr(0, 1),
      grouping: letter
    }
  }

  return {
    found: false,
    ruleLetter: '',
    grouping: ''
  }
};


/**
 * This is related to different answer restrictions in options
 * Extension that states different rules is http://www.documental.ee/questionnaire-answer-set
 * 
 * Currently just return which restriction typ it is (E,S,U,M)
 * 
 * @return string
 */
QuestionnaireHolder.prototype.extractOptionRestrictionExtension = function( option ) {
  var letter = '';

  if( typeof option.extension != 'undefined' && option.extension.length > 0 ){
    for( var i in option.extension ){
      if( option.extension[i].url == 'http://www.documental.ee/questionnaire-answer-set' ){
        letter = option.extension[i].valueString;
      }
    }
  }
  
  return letter;
};



/**
 * TODO: Move options extracting to own class which handles all different ways 
 * to have options for questions. No need to be here- this class don't have to know where options come from
 * 
 * is this even used?
 */
QuestionnaireHolder.prototype.extractOptions = function( questionOrGroup ){
  var options = [];

  if( typeof questionOrGroup.options != 'undefined' && typeof questionOrGroup.reference != 'undefined' ){
    if( questionOrGroup.reference == 'http://www.documental.ee/questionnaire-answer-agree-disagree-nae' ){
      var valueSet = new AgreeDisagreeNae();
      options      = valueSet.getOptions();
    }
  }
  
  if( typeof questionOrGroup.options != 'undefined' && typeof questionOrGroup.reference != 'undefined' ){
    if( questionOrGroup.reference == 'http://www.documental.ee/questionnaire-answer-disagree-nae' ){
      var valueSet = new DisagreeNae();
      options      = valueSet.getOptions();
    }
  }

  return options;
}


/**
 * - 
 * 
 * TODO: needs to be moved out of this class - also used 
 * in QuestionnaireResponseSummary.extractOptionsReference
 * 
 * @return string
 */
QuestionnaireHolder.prototype.extractOptionsReference = function( questionOrGroup ) {
  var reference = '';
  
  if( typeof questionOrGroup.options != 'undefined' && typeof questionOrGroup.options.reference != 'undefined' ){
    reference = questionOrGroup.options.reference;
  }
  
  /*
  Documenat v2 has chema change. 
  example: 
  "answerOption": [
    {
      "valueReference": {
        "reference": "http://www.documental.ee/questionnaire-answer-disagree-nae"
      }
    }
  ],
   */

  if( 
    typeof questionOrGroup.answerOption != 'undefined' && 
    typeof questionOrGroup.answerOption[0].valueReference != 'undefined' ){
    reference = questionOrGroup.answerOption[0].valueReference.reference;
  }

  return reference;
};


/**
 * - 
 * 
 * @return string
 */
QuestionnaireHolder.prototype.hasBooleanQuestionsInChilds = function( questionOrGroup ) {
  var reference = '';
  
  if( typeof questionOrGroup.item != 'undefined'  ){
    for( var i in questionOrGroup.item ){
      if( questionOrGroup.item[i].type == 'boolean' ){
        return true;
      }
    }
  }
  
  return false;
};


/**
 * - 
 * 
 * @return string
 */
QuestionnaireHolder.prototype.hasChildsInChilds = function( questionOrGroup ) {
 
  if( typeof questionOrGroup.item != 'undefined'  ){
    for( var i in questionOrGroup.item ){
      if( typeof questionOrGroup.item != 'undefined' && typeof questionOrGroup.item.length > 0 ){
        return;
      }
    }
  }
  
  return false;
};




/**
 * is question type of 
 *  agree-disagree-nae
 */
QuestionnaireHolder.prototype.IsGroupedAgreeDisagreeNaeTypeQuestions = function( questionOrGroup ) {

  if(questionOrGroup.type == "group" ){
    //console.log( 'START: ' +  questionOrGroup.linkId  );
    //console.log( questionOrGroup );
    
    if( typeof questionOrGroup.item == 'undefined' || questionOrGroup.item.length < 1 ){
      return false;
    }

    var testing = true;

    for( var i in questionOrGroup.item ){
      
      var testRef = window.qHolder.extractOptionsReference( questionOrGroup.item[i] );
      if( testRef == 'http://www.documental.ee/questionnaire-answer-agree-disagree-nae' ){
        //and there should be no subgroups
        if( typeof questionOrGroup.item[i].item != 'undefined' && questionOrGroup.item[i].item.length > 0 ){
          return false;
        }

        //should be choice type
        if( questionOrGroup.item[i].type != 'choice' ){
          return false;
        }
      } else {
        testing = false;
      }

    }

    if( testing ){
      //console.log( 'IsGroupedAgreeDisagreeNaeTypeQuestions: true' + questionOrGroup.linkId );
      return true;
    }

  }

  return false;
}










































/************************************** BOT and other new METHODS ******************************/

/**
  * Recursevly extraxt questions and prepare them as flat list 
  * 
  this.questionsFlatList = this.prepareAsFlatQuestionsList( resource );
  this.questionsQueue = [];

  isSection

 * 
 */
QuestionnaireHolder.prototype.prepareAsFlatQuestionsList = function( level, res, questionInSection ) {
  let questions = [];

  if( res == null || typeof res.item == 'undefined' || res.item.length < 1 ){
    return questions;
  }

  if( level == 1 && this.addRefugeeQuestion ){
		let language = i18n.language;
    
    let fakeRefugeeQuestion = this.getFakeRefugeeQuestion( language );
    questions.push( {
      'questionLinkId' : fakeRefugeeQuestion.linkId,
      'questionJson' : fakeRefugeeQuestion,
      'questionInSection' : null,
      'systemQuestion' : false
    } );

    /** 
    let fakeTopicsQuestion = this.getFakeTopicsQuestion( language );
    let fakeTopicsQuestion2 = this.getFakeTopicsQuestion2( language );
    
    questions.push( {
      'questionLinkId' : fakeTopicsQuestion.linkId,
      'questionJson' : fakeTopicsQuestion,
      'questionInSection' : null,
      'systemQuestion' : false
    } );
    questions.push( {
      'questionLinkId' : fakeTopicsQuestion2.linkId,
      'questionJson' : fakeTopicsQuestion2,
      'questionInSection' : null,
      'systemQuestion' : false
    } );
    */
  }

  if( questionInSection === null || !questionInSection ){
    let definition = this.extractItemDefinition( res );
    if( definition.isSection ){
      questionInSection = definition;
    }
  }

  for( var i in res.item ){
    let isEligbleQuestion = true;
    
    if( typeof res.item[i].type != 'undefined' && ( res.item[i].type === 'group' || res.item[i].type === 'display' ) ){
      isEligbleQuestion = false;
    }

    // if it's a tab- dont trat as a question
    if( res.item[i].linkId.indexOf('.tab') > -1 ){
      isEligbleQuestion = false;
    }

    // for quick teting - take only 5 questions
    if( isEligbleQuestion ){
      // isEligbleQuestion = questions.length < 3;
    }

    if( isEligbleQuestion ){
      questions[ questions.length ] = {
        'questionLinkId' : res.item[i].linkId,
        'questionJson' : res.item[i],
        'questionInSection' : questionInSection,
        'systemQuestion' : false
      };
    }

    /**     
    console.log( 'Extracted TAG' );
    console.log( res.item[i].extension );
    if( typeof res.item[i].extension != 'undefined' && res.item[i].extension.length > 0 ){
      for( var xx in res.item[i].extension ){
        var extension = res.item[i].extension[ xx ];

        if( extension.system == 'http://documental.ee/fhir/codesystem/question/tag' ){
          console.log( extension );
        }
      }
    }
    */

    // if this is a special question marked with http://documental.ee/fhir/profile/questionnaire/item/form1 
    // dont go into items- these are not acutal sperate questions
    let skipSubItems = false;
    if ( typeof res.definition != 'undefined' && res.definition == 'http://documental.ee/fhir/profile/questionnaire/item/form1' ){
      skipSubItems = true;
    }
    

    let subQustions = [];
    if( !skipSubItems ){
      let nextLevel = level +1;
      subQustions =  this.prepareAsFlatQuestionsList( nextLevel, res.item[i], questionInSection );
    }

    if( subQustions.length > 0 ){
      questions = questions.concat( subQustions );
    }
  }
  
  return questions;
}


/**
 * Should we show refugee question? 
 * 
 * @param boolean newValue 
 */
QuestionnaireHolder.prototype.setRefugeeQuestion = function( newValue ) {
  this.addRefugeeQuestion = newValue;
}


QuestionnaireHolder.prototype.moveToPreviousQuestionInQueue = function() {
  
  if( !this.canMoveBackwards() ){
    return false;
  }

  let indexPrev    = this.getPreviousIndexBeforeCurrentQuestion();
  let indexCurrent = this.getCurrentQuestionIndex();
  
  if( indexPrev > -1 ){
    this.questionsQueue.toBeAnswered[ indexPrev ].isPrevious = false;
    this.questionsQueue.toBeAnswered[ indexPrev ].isCurrent = true;
  }
  
  for( var i in  this.questionsQueue.toBeAnswered ){
    if( this.questionsQueue.toBeAnswered[ i ].isPrevious ){
      this.questionsQueue.toBeAnswered[ i ].isPrevious = false;
    }
  }
  
  if( indexCurrent > -1 ){
    this.questionsQueue.toBeAnswered[ indexCurrent ].isPrevious = true;
    this.questionsQueue.toBeAnswered[ indexCurrent ].isCurrent = false;
  }
  console.log( "Updated questions queue with backwards move" );
  console.log( this.getDebugQuestionsQueue() );
}

/**
 * Move to the next question aivable (is next visible question). 
 * 
 * If previously user has moved backward we need to check that previous Queue is still valid 
 * and update Queue frome here on to reflect actual visibility of questions. Some answers can change 
 * that.  
 * 
 * @returns 
 */
QuestionnaireHolder.prototype.moveToNextQuestionInQueue = function() {
  
  window.appEventsEmitter.emit( 'questionnaire-force-send-answers' );
  
  // is moved back in queue? if yes- dont add any- just check opener rules and move forward without adding new qustions onto array

  let nextIndex = this.getNextIndexAfterCurrentQuestion();
  
  if( nextIndex > -1 ){ //  this.getCurrentQuestionIndex() < this.getLastQuestionIndex()
    
    // this.questionsQueue.answeredQuestions
    let isStillOpened = this.isItemVisibleByOpenerRules( this.questionsQueue.toBeAnswered[ nextIndex ].question.questionJson );
    if( !isStillOpened ){
      // TODO: Need to recalculate questions in queue forward this point including this one
      alert('not opened anymore :/ ');
    }
    
    let indexPrev    = -1;
    let indexCurrent = -1;

    for( var i in this.questionsQueue.toBeAnswered ){
      if( this.questionsQueue.toBeAnswered[ i ].isCurrent ){
        indexCurrent = i;
      }
      if( this.questionsQueue.toBeAnswered[ i ].isPrevious ){
        indexPrev = i;
      }
    }
    
    // set all other ppreviouse-s to false to be sure
    for( var i in this.questionsQueue.toBeAnswered ){
      this.questionsQueue.toBeAnswered[ i ].isPrevious = false;
    }

    if( indexPrev > -1 ){
      this.questionsQueue.toBeAnswered[ indexPrev ].isPrevious = false;
      this.questionsQueue.toBeAnswered[ indexPrev ].isCurrent = false;
    }

    if( indexCurrent > -1 ){
      this.questionsQueue.toBeAnswered[ indexCurrent ].isPrevious = true;
      this.questionsQueue.toBeAnswered[ indexCurrent ].isCurrent = false;
    }

    this.questionsQueue.toBeAnswered[ nextIndex ].isPrevious = false;
    this.questionsQueue.toBeAnswered[ nextIndex ].isCurrent = true;

    // done, return
    console.log( 'Updated questions queue with already existing' );
    console.log( this.questionsQueue.toBeAnswered );
    console.log( this.getDebugQuestionsQueue() );
    return;
  }


  
  // set all other ppreviouse-s to false to be sure and set current question be the previous one
  for( var i in this.questionsQueue.toBeAnswered ){
    this.questionsQueue.toBeAnswered[ i ].isPrevious = false;
  }

  let curIndex = this.getCurrentQuestionIndex();
  
  if( curIndex > -1 ){
    this.questionsQueue.toBeAnswered[ curIndex ].isCurrent = false;
    this.questionsQueue.toBeAnswered[ curIndex ].isPrevious = true;
  }
  
  // let newIndex = curIndex + 1;



  // find next visible question from currently active question
  let foundIndex = -1;
  let startingIndexFound = ( curIndex > -1 ? false : true );
  for( var i in this.questionsQueue.toBeAnswered ){
    if( foundIndex < 0 && startingIndexFound ){
      let isOpened = this.isItemVisibleByOpenerRules( this.questionsQueue.toBeAnswered[ i ].question.questionJson );
      if( isOpened ){
        foundIndex = parseInt( i, 10 );
      }
    }
    if( i == curIndex ){
      startingIndexFound = true;
    }
  }

  if( foundIndex > -1 ){
    //console.log( 'Next visible index: ' + foundIndex + ' / ' + this.questionsQueue.toBeAnswered[ foundIndex ].question.questionJson.linkId );
    //console.log( 'SPLICE : 0, ' + (foundIndex + 1) );
    /* 
    this.questionsQueue.answeredQuestions[ newIndex ] = {
      isCurrent : true,
      isPrevious : false,
      linkId : this.questionsQueue.toBeAnswered[ foundIndex ].questionLinkId,
      questionLinkId : this.questionsQueue.toBeAnswered[ foundIndex ].questionLinkId,
      question : this.questionsQueue.toBeAnswered[ foundIndex ].question
    }
    */
    
    // Remove not possible questions currenlty - if someday back button/change answers is implemented we cant do it anymore
    // currently just remove questions
    // this.questionsQueue.toBeAnswered.shift(); // foundIndex
    // this.questionsQueue.toBeAnswered = this.questionsQueue.toBeAnswered.slice( foundIndex );
    // let sliced = this.questionsQueue.toBeAnswered.splice( 0, (foundIndex + 1) );
    /** 
    if( sliced.length ){
      for( var k in sliced ){
        this.questionsQueue.skippedQuestions.push( sliced[ k ] );
      }
    }
    */

    // set all questions between previous active question and new active question to be skipped and not in answeredQuestion and skippedByOpenerRule
    let skipAndRemove = false;
    let cntr = 0;
    if( curIndex > -1 && foundIndex > -1 ){
      for( var i in this.questionsQueue.toBeAnswered ){
        cntr++;
        if( foundIndex == i ){
          skipAndRemove = false;
        }
        if( skipAndRemove ){
          //this.questionsQueue.toBeAnswered[ foundIndex ].answeredQuestion = false;
          //this.questionsQueue.toBeAnswered[ foundIndex ].skippedByOpenerRule = true;
        }
        if(curIndex == i ){
          skipAndRemove = true;
        }
      }
    }

    this.questionsQueue.toBeAnswered[ foundIndex ].isCurrent = true;
    this.questionsQueue.toBeAnswered[ foundIndex ].isPrevious = false;
    this.questionsQueue.toBeAnswered[ foundIndex ].answeredQuestion = true;
    this.questionsQueue.toBeAnswered[ foundIndex ].skippedByOpenerRule = false;
    
    // this.questionsQueue.currentQuestionIndex = newIndex;

  } else {
    // alert( 'Implement questionnaire ended' );
    this.questionsQueue.queueFinished = true;
  }

  console.log( 'New questions queue' );
  console.log( this.questionsQueue.toBeAnswered );
  console.log( this.getDebugQuestionsQueue() );
  
  // isItemVisibleByOpenerRules
  // find next possible index. Take into account that is item visibile by opener rules
  // current queue of questions (where next questions are taken- can change in time)
}



QuestionnaireHolder.prototype.extractItemDefinition = function( item ) {
  let extrcted = {
    isSection : false,
    title : '',
  };

  if( typeof item.definition !== 'undefined' ){
    if( item.definition == "http://documental.ee/fhir/profile/questionnaire/item/sections1" ){
      extrcted.isSection = true;
      extrcted.title = item.text;
    }
  } else if ( typeof item.linkId !== "undefined" && item.linkId.indexOf( 'tab' ) > -1 ){
    extrcted.isSection = true;
    extrcted.title = item.text;
  }

  /**
    "code": [
      {
        "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
        "code": "SR.2.tab",
        "display": "Physical wellness"
      }
    ],
    "text": "Physical wellness",
   *  */  

  return extrcted;
}


/**
 * 
 * 
 */
QuestionnaireHolder.prototype.checkAndSetInitialQuestionsQueue = function() {
  
  if( this.questionsQueue.initialQueueDone ){
    return;
  }

  
  for( var i in  this.questionsFlatList ){
    let skip = false;
    
    if ( 
      typeof this.questionsFlatList[ i ].questionJson.definition != 'undefined' && 
      this.questionsFlatList[ i ].questionJson.definition == 'http://documental.ee/fhir/profile/questionnaire/item/form1'
    ){
      skip = true;
    }
    
    if( !skip ){
      this.questionsQueue.toBeAnswered.push( {
        questionLinkId : this.questionsFlatList[ i ].questionLinkId,
        linkId : this.questionsFlatList[ i ].questionLinkId,
        question : this.questionsFlatList[ i ],

        // used in runtime to determine is this question in answered (ant to be answered) question queue and can't be removed/or moved unless moving back. 
        // Must be used together to resolve next/previous/current  questions
        answeredQuestion : false, // is this question in answered questions queue
        skippedByOpenerRule : false, // Will be later changed and used to filter out questions
        
        isCurrent : false,
        isPrevious : false
      });
    }
  }

  this.moveToNextQuestionInQueue();

  this.questionsQueue.initialQueueDone = true;
}


QuestionnaireHolder.prototype.isQueueDone = function() {
  return this.questionsQueue.queueFinished;
}


QuestionnaireHolder.prototype.canMoveBackwards = function() {
  
  if( this.getCurrentQuestionIndex() > 0 ){
    return true;
  }

  return false;
  /** 
  if( this.questionsQueue.answeredQuestions.length < 2 ){
    return false;
  }
  */
}


QuestionnaireHolder.prototype.isAnsweredEnough = function() {
  let countQuestions = 0;
  for( var i3 in this.questionsQueue.toBeAnswered ){
    if(
      this.questionsQueue.toBeAnswered[ i3 ].answeredQuestion && 
      !this.questionsQueue.toBeAnswered[ i3 ].skippedByOpenerRule 
    ){
      countQuestions++;
    }
  }
  if( countQuestions < 4 ){
    return false;
  }
  
  /* 
  if( this.questionsQueue.answeredQuestions.length < 4 ){
    return false;
  }
  */

  return true;
}




/**
 * 
 */
QuestionnaireHolder.prototype.getLastQuestionIndex = function() {
  let last = -1;
  for( var i3 in this.questionsQueue.toBeAnswered ){
    if(
      this.questionsQueue.toBeAnswered[ i3 ].answeredQuestion && 
      !this.questionsQueue.toBeAnswered[ i3 ].skippedByOpenerRule 
    ){
      last = i3;
    }
  }
  return last;
}


/**
 *
 */
QuestionnaireHolder.prototype.getNextIndexAfterCurrentQuestion = function() {
  let next = -1;
  let nextIsTheIndex = false;

  for( var i6 in this.questionsQueue.toBeAnswered ){
    if( 
      this.questionsQueue.toBeAnswered[ i6 ].answeredQuestion && 
      !this.questionsQueue.toBeAnswered[ i6 ].skippedByOpenerRule 
    ){
      if( nextIsTheIndex ){
        return parseInt( i6 );
      }
      if( this.questionsQueue.toBeAnswered[ i6 ].isCurrent ){
        nextIsTheIndex = true;
      }
    }
  }

  /*
  for( var i6 in this.questionsQueue.answeredQuestions ){
    if( nextIsTheIndex ){
      return parseInt( i6 );
    }
    if( this.questionsQueue.answeredQuestions[ i6 ].isCurrent ){
      nextIsTheIndex = true;
    }
  }
  */

  return next;
}


/**
 *
 */
QuestionnaireHolder.prototype.getPreviousIndexBeforeCurrentQuestion = function() {
  let previous = -1;

  for( var i7 in this.questionsQueue.toBeAnswered ){
    if(
      !this.questionsQueue.toBeAnswered[ i7 ].skippedByOpenerRule && 
      this.questionsQueue.toBeAnswered[ i7 ].answeredQuestion 
    ){
      if( this.questionsQueue.toBeAnswered[ i7 ].isCurrent ){
        return previous;
      }
      previous = i7;
    }
  }
  
  return -1;
}


/**
 * Get currnently active question's index
 */
QuestionnaireHolder.prototype.getCurrentQuestionIndex = function() {
  
  for( var i in this.questionsQueue.toBeAnswered ){
    if(
      this.questionsQueue.toBeAnswered[ i ].isCurrent &&
      !this.questionsQueue.toBeAnswered[ i ].skippedByOpenerRule && 
      this.questionsQueue.toBeAnswered[ i ].answeredQuestion 
    ){
      return parseInt( i, 10 );
    }
  }

  return -1;
}


/**
 * Get currnently active question's index
 */
QuestionnaireHolder.prototype.getPreviousQuestionIndex = function() {
  this.checkAndSetInitialQuestionsQueue();

  for( var i in this.questionsQueue.toBeAnswered ){
    if( 
      this.questionsQueue.toBeAnswered[ i ].isPrevious && 
      !this.questionsQueue.toBeAnswered[ i ].skippedByOpenerRule  && 
      this.questionsQueue.toBeAnswered[ i ].answeredQuestion 
    ){
      return parseInt( i, 10 );
    }
  }

  return -1;
}


/**
 * Get currnently active question
 */
QuestionnaireHolder.prototype.getCurrentQuestion = function() {
  this.checkAndSetInitialQuestionsQueue();

  for( var i in this.questionsQueue.toBeAnswered ){
    if( 
      this.questionsQueue.toBeAnswered[ i ].isCurrent && 
      !this.questionsQueue.toBeAnswered[ i ].skippedByOpenerRule  && 
      this.questionsQueue.toBeAnswered[ i ].answeredQuestion 
    ){
      const copied = Object.assign({},  this.questionsQueue.toBeAnswered[ i ] )
      return copied;
    }
  }

  return null;
}


/**
 * Get last active question
 * 
 *     
 */
QuestionnaireHolder.prototype.getPreviousQuestion = function() {
  this.checkAndSetInitialQuestionsQueue();
  
  for( var i in this.questionsQueue.toBeAnswered ){
    if( 
      this.questionsQueue.toBeAnswered[ i ].isPrevious && 
      !this.questionsQueue.toBeAnswered[ i ].skippedByOpenerRule  && 
      this.questionsQueue.toBeAnswered[ i ].answeredQuestion 
    ){
      const copied = Object.assign({},  this.questionsQueue.toBeAnswered[ i ] )
      return copied;
    }
  }

  return null;
}



/**
 * Get percentage done
 */
QuestionnaireHolder.prototype.getPercentageDone = function() {
  if( typeof this.questionsQueue == 'undefined' || typeof this.questionsQueue.answeredQuestions == 'undefined' ){
    return 0;
  }

  let all = this.questionsQueue.answeredQuestions.length + this.questionsQueue.toBeAnswered.length;

  let x = 100 * (this.questionsQueue.toBeAnswered.length / all);

  // TODO: Take into account is skippedByOpenerRule flag set or not

  return 100 - Math.round( x );
}


/**
 * 
 * @returns boolean
 */
QuestionnaireHolder.prototype.isFakeRefugeeQuestion = function( linkId ) {
  if( linkId === 'SR.0.0' ){
    return true;
  }
  
  return false;
}

/**
 * This question is not sent to server as part of self assessment questionnaireResponse
 * but intead handled seperatley on client side (this app)
 * 
 * @param {*} language 
 * @returns 
 */
QuestionnaireHolder.prototype.getFakeRefugeeQuestion = function( language ) {

  /* 
  old answers until 2024-01-31
  let answers = [ 
    {
      'linkId' : 'SR.0.0.1',
      'code' : 'KW01',
      'et' : 'Ma elan Ukrainas ',
      'en' : 'I live in Ukraine ',
      'ru' : 'Проживаю в Украине ',
      'uk' : 'Живу в Україні '
    },
    {
      'linkId' : 'SR.0.0.2',
      'code' : 'KW02',
      'et' : 'Sisepagulane',
      'en' : 'Internally displaced person',
      'ru' : 'ВПО на территории Украины',
      'uk' : 'ВПО на території  України'
    },
    {
      'linkId' : 'SR.0.0.3',
      'code' : 'KW03',
      'et' : 'Ma elan teise riigi territooriumil (pagulane Ukrainast)',
      'en' : 'I live on the territory of another country (refugee from Ukraine)',
      'ru' : 'Проживаю на территории другой страны (беженец из Украины)',
      'uk' : 'Проживаю на території іншої країни (біженець з України)'
    },
	{
      'linkId' : 'SR.0.0.4',
      'code' : 'KW04',
      'et' : 'Teine',
      'en' : 'Another',
      'ru' : 'Другой',
      'uk' : 'Інший'
    },
  ];
  */

  // new answers with new code : "SR.0.0.99"
  /**
   * I live in Ukraine   -> I live in Ukraine: I have not changed my place of residence
   * Internally displaced person -> I live in Ukraine: Internally displaced person inside Ukraine
   * PUUDUB  HETKEL -> I live in Estonia (refugee from Ukraine)
   * I live on the territory of another country (refugee from Ukraine) -> SAMA TEKST
   * Another -> Other
   * 
   * 
   */

  let answers = [ 
    {
      'linkId' : 'SR.0.0.1',
      'code' : 'KW01',
      'et' : 'Ma elan Ukrainas ',
      'en' : 'I live in Ukraine: I have not changed my place of residence',
      'ru' : 'Проживаю в Украине: не менял(a) места жительства',
      'uk' : 'Проживаю в Україні: не міняв місця проживання'
    },
    {
      'linkId' : 'SR.0.0.2',
      'code' : 'KW02',
      'et' : 'Sisepagulane',
      'en' : 'I live in Ukraine: Internally displaced person inside Ukraine',
      'ru' : 'Проживаю в Украине: переселенец внутри Украины',
      'uk' : 'Проживаю в Україні: переселенець всередині України'
    },
    {
      'linkId' : 'SR.0.0.99',
      'code' : 'KW99',
      'et' : 'Elan Eestis (pagulane Ukrainast)',
      'en' : 'I live in Estonia (refugee from Ukraine)',
      'ru' : 'Проживаю в Эстонии (беженец из Украины)',
      'uk' : 'Проживаю в Естонії (біженець з України)'
    },
    {
      'linkId' : 'SR.0.0.3',
      'code' : 'KW03',
      'et' : 'Ma elan teise riigi territooriumil (pagulane Ukrainast)',
      'en' : 'I live on the territory of another country (refugee from Ukraine)',
      'ru' : 'Проживаю на территории другой страны (беженец из Украины)',
      'uk' : 'Проживаю на території іншої країни (біженець з України)'
    },
  {
      'linkId' : 'SR.0.0.4',
      'code' : 'KW04',
      'et' : 'Teine',
      'en' : 'Other',
      'ru' : 'Другой',
      'uk' : 'Інший'
    },
  ];

  let translated1 = 'Your current status?';

  if( language == 'et' ){
    translated1 = 'Teie praegune olek?';
  } else if( language == 'ru' ){
    translated1 = 'Ваш статус на данный момент?';
  } else if( language == 'uk' ){
    translated1 = 'Ваш статус на даний момент?';
  }
  
  // valueString
  let fakeQuestion = {
    "linkId": "SR.0.0",
    "definition": "http://documental.ee/fhir/profile/questionnaire/item/choice1",
    "code": [{
        "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
        "code": "SR.0.0",
        "display": translated1
      }
    ],
    "text": translated1,
    "type": "choice",
    "repeats": false,
    "answerOption": []
  };

  for( var i in answers ){
    let item = answers[ i ];
    let translated2 = item.en;

    if( language == 'et' ){
      translated2 = item.et;
    } else if( language == 'ru' ){
      translated2 = item.ru;
    } else if( language == 'uk' ){
      translated2 = item.uk;
    }

    fakeQuestion.answerOption.push({
      "valueCoding": {
        "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
        "code": item.linkId,
        "display": translated2
      }
    });
  }

  return fakeQuestion;

}


/**
 * Now SR.0.0 is in use for refugee question
 * 
 * @param string language 
 * @return object
QuestionnaireHolder.prototype.getFakeTopicsQuestion = function( language ) {
  // Now SR.0.0 is in use for refugee question
  let topics = [ 
    {
      'linkId' : 'SR.0.0.1',
      'code' : 'KW01',
      'et' : 'Meeleolu / emotsioonid',
      'en' : 'Mood / emotions',
      'ru' : 'настроение / эмоции'
    },
    {
      'linkId' : 'SR.0.0.2',
      'code' : 'KW02',
      'et' : 'Ärevus / hirmud',
      'en' : 'Anxiety / fears',
      'ru' : 'тревога / страхи'	
    },
    {
      'linkId' : 'SR.0.0.3',
      'code' : 'KW03',
      'et' : 'Ärrituvus / agressiivsus',
      'en' : 'Irritability / aggression',
      'ru' : 'раздражительность / агрессия',			
    },
    {
      'linkId' : 'SR.0.0.4',
      'code' : 'KW04',
      'et' : 'Impulsiivsus / mõtlematus',
      'en' : 'Impulsivity / thoughtlessness',
      'ru' : 'импульсивность / необдуманность',
    },
    {
      'linkId' : 'SR.0.0.5',
      'code' : 'KW05',
      'et' : 'Uni',
      'en' : 'Sleep',
      'ru' : 'сон',
    },
    {
      'linkId' : 'SR.0.0.6',
      'code' : 'KW06',
      'et' : 'Söögiisu / kehakaal',
      'en' : 'Appetite / weight',
      'ru' : 'аппетит / вес',
    },
    {
      'linkId' : 'SR.0.0.7',
      'code' : 'KW07',
      'et' : 'Keskendumine / tähelepanu',
      'en' : 'Concentration / attention',
      'ru' : 'концентрация / внимание',
    },
    {
      'linkId' : 'SR.0.0.8',
      'code' : 'KW08',
      'et' : 'Mälu',
      'en' : 'Memory',
      'ru' : 'память',
    },
    {
      'linkId' : 'SR.0.0.9',
      'code' : 'KW09',
      'et' : 'Alkohol / narkootikumid',
      'en' : 'Alcohol / drugs',
      'ru' : 'алкоголь / наркотики',
    },
    {
      'linkId' : 'SR.0.0.10',
      'code' : 'KW10',
      'et' : 'Mängu / muu sõltuvused',
      'en' : 'Game / other addictions',
      'ru' : 'игровая / другая зависимость ',
    },
    {
      'linkId' : 'SR.0.0.11',
      'code' : 'KW11',
      'et' : 'Surma mõtted / enesevigastamine',
      'en' : 'Thoughts of death / self-harm',
      'ru' : 'мысли о смерти / самоповреждение',
    },
    {
      'linkId' : 'SR.0.0.12',
      'code' : 'KW12',
      'et' : 'Sundmõtted / sundteod',
      'en' : 'Obsessions / compulsive actions',
      'ru' : 'навязчивые идеи / действия',
    },
    {
      'linkId' : 'SR.0.0.13',
      'code' : 'KW13',
      'et' : 'Ebatavalised mõtted / ideed',
      'en' : 'Unusual thoughts / ideas',
      'ru' : 'необычные мысли / идеи',
    },
    {
      'linkId' : 'SR.0.0.14',
      'code' : 'KW14',
      'et' : 'ebatavaline taju / hääled / hallutsinatsioonid',
      'en' : 'unusual perceptions / voices / hallucinations',
      'ru' : 'необычные восприятия / голоса / галлюцинации ',
    },
    {
      'linkId' : 'SR.0.0.15',
      'code' : 'KW15',
      'et' : 'seksuaalne tegevus / eelistus',
      'en' : 'sexual activity / preference',
      'ru' : 'сексуальная активность / предпочтения',
    },
    {
      'linkId' : 'SR.0.0.16',
      'code' : 'KW16',
      'et' : 'enesehinnang',
      'en' : 'self-esteem',
      'ru' : 'самооценка',
    },
    {
      'linkId' : 'SR.0.0.17',
      'code' : 'KW17',
      'et' : 'Energia / väsimus',
      'en' : 'Energy / fatigue',
      'ru' : 'энергия / усталость',
    },
    {
      'linkId' : 'SR.0.0.18',
      'code' : 'KW18',
      'et' : 'Motivatsioon / huvi / nauding',
      'en' : 'Motivation / interest / pleasure',
      'ru' : 'мотивация / интерес / удовольствие',
    },	
    {
      'linkId' : 'SR.0.0.19',
      'code' : 'KW19',
      'et' : 'Tervis / füüsilised sümptomid',
      'en' : 'Health / physical symptoms',
      'ru' : 'здоровье / физические симптомы',
    },
    {
      'linkId' : 'SR.0.0.20',
      'code' : 'KW20',
      'et' : 'välimus',
      'en' : 'appearance',
      'ru' : 'внешний вид',
    },
    {
      'linkId' : 'SR.0.0.21',
      'code' : 'KW21',
      'et' : 'Toimimine / võimekus',
      'en' : 'Functioning / ability',
      'ru' : 'функционирование / дееспособность',
    },
    {
      'linkId' : 'SR.0.0.22',
      'code' : 'KW22',
      'et' : 'Sotsiaalne tegevus',
      'en' : 'Social activity',
      'ru' : 'социальная активность',
    },
    {
      'linkId' : 'SR.0.0.23',
      'code' : 'KW23',
      'et' : 'Konfliktid / suhted',
      'en' : 'Conflicts / relationships',
      'ru' : 'конфликты / взаимоотношения',
    },
    {
      'linkId' : 'SR.0.0.24',
      'code' : 'KW24',
      'et' : 'Käitumine',
      'en' : 'Behavior',
      'ru' : 'поведение',
    },
    {
      'linkId' : 'SR.0.0.25',
      'code' : 'KW25',
      'et' : 'Segasus',
      'en' : 'Confusion',
      'ru' : 'растерянность',
    },
    {
      'linkId' : 'SR.0.0.26',
      'code' : 'KW26',
      'et' : 'Desorientatsioon',
      'en' : 'Disorientation',
      'ru' : 'дезориентация',
    },
    {
      'linkId' : 'SR.0.0.27',
      'code' : 'KW27',
      'et' : 'Motoorika / koordinatsioon',
      'en' : 'Motor skills / coordination',
      'ru' : 'моторика / координация',
    },
    {
      'linkId' : 'SR.0.0.28',
      'code' : 'KW28',
      'et' : 'Enesehooldus',
      'en' : 'Self-care',
      'ru' : 'личный уход',
    },
    {
      'linkId' : 'SR.0.0.29',
      'code' : 'KW29',
      'et' : 'Muud',
      'en' : 'Other',
      'ru' : 'другое',
    }
  ];

  let questionTranlsated = 'Choose up to seven issues that are of most concern or importance to you';
  if( language == 'et' ){
    questionTranlsated = 'Valige kuni seitse teie jaoks kõige suuremat muret või tähtsust omavat probleeme';
  } else if ( language == 'ru' ) {
    questionTranlsated = 'Выберите до семи вопросов, которые вас больше всего беспокоят или важны';
  }

  // Now SR.0.0 is in use for refugee question
  let fakeQuestion = {
    "linkId": "SR.0.0",
    "definition": "http://documental.ee/fhir/profile/questionnaire/item/choice1",
    "code": [{
        "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
        "code": "SR.0.0",
        "display": questionTranlsated
      }
    ],
    "text": questionTranlsated,
    "type": "choice",
    "repeats": true,
    "answerOption": [
      / ** 
      {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.1",
          "display": "Ärrituvus/agressiivsus"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.2",
          "display": "Uni"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.3",
          "display": "Mälu"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.4",
          "display": "Mängu-/muud sõltuvused"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.5",
          "display": "Surmamõtted/enesevigastamine"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.6",
          "display": "Mälu"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.7",
          "display": "agressiivsus"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.8",
          "display": "Mängu-/muud sõltuvused"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.9",
          "display": "Ärrituvus"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.10",
          "display": "Psychotic disorders"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.11",
          "display": "Somatoform and elaboration disorders"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.12",
          "display": "This is very long issue description #10"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.13",
          "display": "This is very long issue description for scroll #9"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.14",
          "display": "Very long issue description for scroll #8"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.15",
          "display": "This is very long issue description for scroll #6"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.16",
          "display": "Very long issue #7"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.17",
          "display": "This is very long issue description #5"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.18",
          "display": "Long issue description for scroll #4"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.19",
          "display": "This is very long issue description #2"
        }
      }, {
        "valueCoding": {
          "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
          "code": "SR.0.0.20",
          "display": "Very long issue #1"
        }
      }
      * /
      
    ]
  }

  
  for( var i in topics ){
    let item = topics[ i ];
    let translated1 = item.en;

    if( language == 'et' ){
      translated1 = item.et;
    } else if( language == 'ru' ){
      translated1 = item.ru;
    }

    fakeQuestion.answerOption.push({
      "valueCoding": {
        "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
        "code": item.linkId,
        "display": translated1
      }
    });
  }


  return fakeQuestion;
}

*/


/*
QuestionnaireHolder.prototype.getFakeTopicsQuestion2 = function( language ) {
  
  let translated1 = 'What else do you want to add about your issue?';

  if( language == 'et' ){
    translated1 = 'Mida soovite veel lisada oma probleemi kohta?';
  } else if( language == 'ru' ){
    translated1 = 'Что еще вы хотите добавить о своей проблеме?';
  }

  // valueString
  let fakeQuestion = {
    "linkId": "SR.0.1",
    "definition": "http://documental.ee/fhir/profile/questionnaire/item/choice1",
    "code": [{
        "system": "http://documental.ee/fhir/codesystem/questionnaire/item",
        "code": "SR.0.1",
        "display": translated1
      }
    ],
    "text": translated1,
    "type": "text",
    "repeats": false
  }

  return fakeQuestion;
}
*/



QuestionnaireHolder.prototype.getCurrentQuestionnaireResponseMatrix = function( language ) {
  let matrix = {
    topics : []
  };

  let topics = [ {
    'code' : 'PROB01',
    'et' : 'Meeleoluhäired',
    'en' : 'Mood disorders',
    'ru' : 'Расстройства настроения',
  }, {
    'code' : 'PROB02',
    'et' : 'Ärevushäired',
    'en' : 'Anxiety disorders',
    'ru' : 'Тревожные расстройства',
  }, {
    'code' : 'PROB03',
    'et' : 'Obsessiiv-kompulsiivne häire',
    'en' : 'Obsessive-compulsive disorder',
    'ru' : 'Обсессивно-компульсивное расстройство',
  }, {
    'code' : 'PROB04',
    'et' : 'Psühhootilised häired',
    'en' : 'Psychotic disorders',
    'ru' : 'Психотические расстройства',
  }, {
    'code' : 'PROB05',
    'et' : 'Tajumine',
    'en' : 'Perception',
    'ru' : 'Восприятие',
  }, {
    'code' : 'PROB06',
    'et' : 'Kognitiivsed probleemid',
    'en' : 'Cognitive problems',
    'ru' : 'Когнитивные проблемы',
  }, {
    'code' : 'PROB07',
    'et' : 'Somatoformsed häired',
    'en' : 'Somatoform disorders',
    'ru' : 'Соматоформные расстройства',
  }, {
    'code' : 'PROB08',
    'et' : 'Ajukahjustus',
    'en' : 'Brain injury',
    'ru' : 'Травма головного мозга',
  }, {
    'code' : 'PROB09',
    'et' : 'Kehalised haigused',
    'en' : 'Physical illnesses',
    'ru' : 'Физические болезни',
  }, {
    'code' : 'PROB10',
    'et' : 'Unehäired',
    'en' : 'Sleep disorders',
    'ru' : 'Нарушения сна',
  }, {
    'code' : 'PROB11',
    'et' : 'Söömishäired',
    'en' : 'Eating disorders',
    'ru' : 'Расстройства приема пищи',
  }, {
    'code' : 'PROB12',
    'et' : 'Kehaline aktiivsus',
    'en' : 'Physical activity',
    'ru' : 'Физическая активность',
  }, {
    'code' : 'PROB13',
    'et' : 'Seksuaalne aktiivsus',
    'en' : 'Sexual activity',
    'ru' : 'Сексуальная активность',
  }, {
    'code' : 'PROB14',
    'et' : 'Alkoholi ja teiste ainede kasutamine',
    'en' : 'Alcohol and other substances use',
    'ru' : 'Употребление алкоголя и других веществ',
  }, {
    'code' : 'PROB15',
    'et' : 'Funktsionaalsus',
    'en' : 'Functionality',
    'ru' : 'Функциональность',
  }, {
    'code' : 'PROB16',
    'et' : 'Õppimishäired',
    'en' : 'Learning disorders',
    'ru' : 'Нарушения обучения',
  }, {
    'code' : 'PROB17',
    'et' : 'Suhed',
    'en' : 'Relationships',
    'ru' : 'Отношения',
  }, {
    'code' : 'PROB18',
    'et' : 'Sotsiaalelu',
    'en' : 'Social life',
    'ru' : 'Социальная жизнь',
  }, {
    'code' : 'PROB19',
    'et' : 'Isiksusehäired',
    'en' : 'Personality disorders',
    'ru' : 'Расстройства личности',
  }, {
    'code' : 'PROB20',
    'et' : 'Enesehinnang',
    'en' : 'Self-esteem',
    'ru' : 'Самооценка',
  }, {
    'code' : 'PROB21',
    'et' : 'Ohutus',
    'en' : 'Safety ',
    'ru' : 'Безопасность',
  }, {
    'code' : 'PROB22',
    'et' : 'Impulsiivsus',
    'en' : 'Impulsivity',
    'ru' : 'Импульсивность',
  }, {
    'code' : 'PROB23',
    'et' : 'Stressiga seotud häired',
    'en' : 'Stress-related disorders',
    'ru' : 'Расстройства, связанные со стрессом',
  }, {
    'code' : 'PROB24',
    'et' : 'Heaolu',
    'en' : 'Welfare',
    'ru' : 'Благосостояние',
  } ];
  
  for( var jj in topics ){
    if( language == 'et' ){
      matrix.topics.push( this.createMatrixContentItem( topics[ jj ].et )  );
    } else if( language == 'ru' ){
      matrix.topics.push( this.createMatrixContentItem( topics[ jj ].ru )  );
    } else {
      matrix.topics.push( this.createMatrixContentItem( topics[ jj ].en )  );
    }
  }

  return matrix;
}


QuestionnaireHolder.prototype.createMatrixContentItem = function( title ) {

  let percentDone = this.getPercentageDone();
  percentDone = percentDone * 8;
  if(percentDone > 100){
    percentDone = 100;
  }
  let heatRnd = Math.floor( Math.random() * percentDone );
  let heat = 0;
  

  if( heatRnd > 5 ){
    // heat = 26;
  }
  if( heatRnd > 25 ){
    heat = 26;
  }
  if( heatRnd > 50 ){
    heat = 76;
  }
  if( heatRnd > 80 ){
    heat = 100;
  }


  return {
    'title' : title,
    'progress' : heat, // heat-1
    'infoText' : ''
  }
}

QuestionnaireHolder.prototype.getDebugQuestionsQueue = function() {
  let list = [];
  let feMore = 0;

  for( var jj in this.questionsQueue.toBeAnswered ){
    //if( this.questionsQueue.toBeAnswered ){
      let str = this.questionsQueue.toBeAnswered[ jj ].questionLinkId.padEnd( 10, ' ' );

      str = str + ( this.questionsQueue.toBeAnswered[ jj ].answeredQuestion ? ' QUEUED ' : ' ------ ' );
      str = str + ( this.questionsQueue.toBeAnswered[ jj ].skippedByOpenerRule ? ' SKIP ' : ' ---- ' );
      str = str + ( this.questionsQueue.toBeAnswered[ jj ].isCurrent ? ' CUR ' : ' --- ' );
      str = str + ( this.questionsQueue.toBeAnswered[ jj ].isPrevious ? ' PRE ' : ' --- ' );

      feMore++;

      // push into list only if something is set and 1 after them 
      if( 
        feMore < 3 ||
        this.questionsQueue.toBeAnswered[ jj ].answeredQuestion ||
        this.questionsQueue.toBeAnswered[ jj ].skippedByOpenerRule || 
        this.questionsQueue.toBeAnswered[ jj ].isCurrent ||
        this.questionsQueue.toBeAnswered[ jj ].isPrevious 
       ){
        list.push( str );
      }

      if( 
        this.questionsQueue.toBeAnswered[ jj ].answeredQuestion ||
        this.questionsQueue.toBeAnswered[ jj ].skippedByOpenerRule || 
        this.questionsQueue.toBeAnswered[ jj ].isCurrent ||
        this.questionsQueue.toBeAnswered[ jj ].isPrevious 
       ){
        feMore = 0;
      }
    //}
  }

  /**
   * : true
  isCurrent: false
  isPrevious: false
  linkId: "SR.0.1"
  question: {questionLinkId: 'SR.0.1', questionJson: {…}, questionInSection: {…}, systemQuestion: false}
  questionLinkId: "SR.0.1"
  skippedByOpenerRule: false
   */

  // console.log( list );

  return list.join( "\r\n" );
}

/************************************** BOT and other new METHODS END ******************************/




QuestionnaireHolder.prototype.setCurrentQuestionnaireResponseStatus = function( statusString, forceSendAnswers ) {
  this.forceQuestionnaireReponseStatus = statusString;
  if( forceSendAnswers ){
    window.appEventsEmitter.emit( 'questionnaire-force-send-answers' );
  }
}


QuestionnaireHolder.prototype.getCurrentQuestionnaireResponseStatus = function() {

  if( this.forceQuestionnaireReponseStatus != null ){
    return this.forceQuestionnaireReponseStatus;
  }

  return 'in-progress';
}





export default QuestionnaireHolder; 
